webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = {
	// apiUrl: 'http://beta.merck.ph/api'
	// apiUrl: '//localhost:8070/api',
	// apiUrl: 'http://merck-laravel-api.ap-southeast-1.elasticbeanstalk.com/api'
	// apiUrl: 'http://ph-web02.seap-cloud.com/merck-api/public/api',
	apiUrl: '//www.elitevirtuallearning.com/merck-api/public/api',
	filesUrl: 'http://elite-ph.s3.amazonaws.com/',

}

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/water_6.9746f39.png";

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAuthToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setAuthToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteAuthToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteUser; });
var getAuthToken = function getAuthToken() {
  var token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return token;
};

var setAuthToken = function setAuthToken(token) {
  localStorage.setItem('token', token);
  sessionStorage.setItem('token', token);
};

var deleteAuthToken = function deleteAuthToken() {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
};

var getUser = function getUser() {
  var user = localStorage.getItem('user') || sessionStorage.getItem('user');
  return user ? JSON.parse(user) : {};
};

var deleteUser = function deleteUser() {
  localStorage.removeItem('user');
  sessionStorage.removeItem('user');
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ELITE Logo.bb8f315.svg";

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainFooter_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4ab8a4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainFooter_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4ab8a4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardHeader_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac915b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardHeader_vue__ = __webpack_require__(337);
function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac915b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjE3NDMgNTI2NiA0My41NyA1MC41ODUiPg0KICA8ZGVmcz4NCiAgICA8c3R5bGU+DQogICAgICAuY2xzLTEgew0KICAgICAgICBmaWxsOiAjZTgyZThhOw0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPGcgaWQ9Ikdyb3VwXzI0MyIgZGF0YS1uYW1lPSJHcm91cCAyNDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0MjcgNDc5NikiPg0KICAgIDxwYXRoIGlkPSJQYXRoXzYzOSIgZGF0YS1uYW1lPSJQYXRoIDYzOSIgY2xhc3M9ImNscy0xIiBkPSJNNjMuMTk0LDE5LjkzMkg1Ny4yODZ2My42OTJoNC4wNjJ2Ni45NTRhMTEuMDc3LDExLjA3NywwLDAsMS0yMi4xNTQsMFYyMy42MjRoMy45MzlWMTkuOTMySDM3LjM0N0ExLjg0NiwxLjg0NiwwLDAsMCwzNS41LDIxLjc3OHY4LjhhMTQuNzY5LDE0Ljc2OSwwLDEsMCwyOS41MzksMHYtOC44QTEuODQ2LDEuODQ2LDAsMCwwLDYzLjE5NCwxOS45MzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODAuNDk5IDQ1Mi4wMzcpIi8+DQogICAgPHBhdGggaWQ9IlBhdGhfNjQwIiBkYXRhLW5hbWU9IlBhdGggNjQwIiBjbGFzcz0iY2xzLTEiIGQ9Ik0xODYuNTg4LDI2Mi40Mzd2OC43MzlhOS4yMzEsOS4yMzEsMCwwLDEtMTguNDYyLDBWMjU5LjExNGgtMy42OTJ2MTIuMDYyYTEyLjkyMywxMi45MjMsMCwwLDAsMjUuODQ2LDB2LTguNzM5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY0LjMwNSAyMzYuNDg2KSIvPg0KICAgIDxwYXRoIGlkPSJQYXRoXzY0MSIgZGF0YS1uYW1lPSJQYXRoIDY0MSIgY2xhc3M9ImNscy0xIiBkPSJNMzQ1LjA0NywxNzEuOTEyYTYuODMxLDYuODMxLDAsMSwwLDYuODMxLDYuODMxQTYuODM4LDYuODM4LDAsMCwwLDM0NS4wNDcsMTcxLjkxMlptMCw5Ljk2OWEzLjEzOCwzLjEzOCwwLDEsMSwzLjEzOC0zLjEzOEEzLjE0MiwzLjE0MiwwLDAsMSwzNDUuMDQ3LDE4MS44ODFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjY5MSAzMTUuMDczKSIvPg0KICAgIDxwYXRoIGlkPSJQYXRoXzY0MiIgZGF0YS1uYW1lPSJQYXRoIDY0MiIgY2xhc3M9ImNscy0xIiBkPSJNOTUuMjc0LDBhMS44NDYsMS44NDYsMCwwLDAtMS44NDYsMS44NDZWNS43ODVhMS44NDYsMS44NDYsMCwwLDAsMy42OTIsMFYxLjg0NkExLjg0NiwxLjg0NiwwLDAsMCw5NS4yNzQsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyOC4yOTUgNDcwKSIvPg0KICAgIDxwYXRoIGlkPSJQYXRoXzY0MyIgZGF0YS1uYW1lPSJQYXRoIDY0MyIgY2xhc3M9ImNscy0xIiBkPSJNMjM5Ljc4LDBhMS44NDYsMS44NDYsMCwwLDAtMS44NDYsMS44NDZWNS43ODVhMS44NDYsMS44NDYsMCwwLDAsMy42OTIsMFYxLjg0NkExLjg0NiwxLjg0NiwwLDAsMCwyMzkuNzgsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk4LjA2NiA0NzApIi8+DQogIDwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__server_data_json__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__server_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__server_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apiUrl: '//localhost:8000/api',
      serverData: __WEBPACK_IMPORTED_MODULE_1__server_data_json___default.a
    };
  },

  props: {
    toolbar: {
      default: false
    }
  }

  // Axios Config Interceptors
});__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
  if (localStorage.getItem('token') != null) {
    var access = localStorage.getItem('token');
    config.headers['Authorization'] = 'Bearer ' + access;
  }

  return config;
}, function (error) {
  // Do something with request error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_carousel__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_sampleModules__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_parallax__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_registration__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mainFooter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_token__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_0__components_home_carousel__["a" /* default */],
    SampleModules: __WEBPACK_IMPORTED_MODULE_1__components_home_sampleModules__["a" /* default */],
    Parallax: __WEBPACK_IMPORTED_MODULE_2__components_home_parallax__["a" /* default */],
    Registration: __WEBPACK_IMPORTED_MODULE_3__components_home_registration__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_4__components_mainFooter__["a" /* default */]
  },
  data: function data() {
    return {
      bg: __webpack_require__(7),
      token: Object(__WEBPACK_IMPORTED_MODULE_5__utils_token__["c" /* getAuthToken */])()
    };
  },

  methods: {
    loginClick: function loginClick() {
      this.$router.push('/login');
    },
    goToDashboard: function goToDashboard() {
      this.$router.push('/dashboard');
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_slide1__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_slide2__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_slide3__ = __webpack_require__(306);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    slide1: __WEBPACK_IMPORTED_MODULE_0__components_home_slide1__["a" /* default */],
    slide2: __WEBPACK_IMPORTED_MODULE_1__components_home_slide2__["a" /* default */],
    slide3: __WEBPACK_IMPORTED_MODULE_2__components_home_slide3__["a" /* default */]
  },
  data: function data() {
    return {
      items: [{
        src: __WEBPACK_IMPORTED_MODULE_0__components_home_slide1__["a" /* default */]
      }, {
        src: __WEBPACK_IMPORTED_MODULE_1__components_home_slide2__["a" /* default */]
      }, {
        src: __WEBPACK_IMPORTED_MODULE_2__components_home_slide3__["a" /* default */]
      }]
    };
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      logo: __webpack_require__(11),
      bg: __webpack_require__(302)
    };
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(7)
    };
  },

  methods: {
    goto: function goto() {
      var container = document.getElementById('regFormContainer');
      window.scrollTo(0, container.offsetTop);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__server_lecturers_json__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__server_lecturers_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__server_lecturers_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(66),
      lecturers: __WEBPACK_IMPORTED_MODULE_0__server_lecturers_json___default.a.items
    };
  }
});

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = {"items":[{"id":"teofilo","link":"/author/teofilo","media":"/static/img/teofilo-san-luis-jr.jpg","title":"DR. TEOFILO O.L. SAN LUIS, JR., MD","text":"National Coordinator Iodine Global Network (IGN) - Philippines."},{"id":"kho","link":"/author/kho","media":"/static/img/sjoberg_kho.jpg","title":"DR. SJOBERG ANG KHO, M.D.","text":"Associate Professor, University of Santo Tomas - Faculty of Medicine and Surgery"},{"id":"nicodemus","link":"/author/nicodemus","media":"/static/img/dr_nicodemus_2016.jpg","title":"DR. NEMENCIO ALMARE NICODEMUS JR., MD","text":"Professor, University of the Philippines - College of Medicine"}]}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/access.97b705a.png";

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var apiUrl = __WEBPACK_IMPORTED_MODULE_1__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    sampleModules: function sampleModules() {
      return this.modules.slice(0, 3); // get first 3 elements
    }
  },
  data: function data() {
    return {
      modules: []
    };
  },

  methods: {
    getModules: function getModules() {
      var _this = this;

      if (navigator.onLine) {
        console.log('User is online - Fetching info from server');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + '/home/module').then(function (e) {
          if (e.data.length > 0) {
            _this.$set(_this, 'modules', e.data);
          }
        }).catch(function (e) {
          console.log('error', e);
        });
      } else {
        console.log('User is offline - Fetching info from localstorage');
      }
    }
  },
  mounted: function mounted() {
    this.getModules();
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(312)
    };
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profile_privacyPolicy__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__configApi__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var API_URL = __WEBPACK_IMPORTED_MODULE_3__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PrivacyPolicy: __WEBPACK_IMPORTED_MODULE_2__components_profile_privacyPolicy__["a" /* default */]
  },
  data: function data() {
    return {
      mobileNumberInputField: null,
      snackbar: false,
      text: "",
      privacyPolicyDialog: false,
      notificationResponse: false,
      firstName: "",
      lastName: "",
      wholeName: "",
      middleName: "",
      nickname: "",
      birthday: "",
      primaryContactNumber: "",
      secondaryContactNumber: "",
      emailAddress: "",
      password: "",
      otherContactDetails: "",
      prcNumber: "",
      mcrNumber: "",
      icNumber: "",
      prcRegistrationDate: "",
      prcValidity: "",
      firstNameRules: [function (v) {
        return !!v || "First Name is required";
      }],
      lastNameRules: [function (v) {
        return !!v || "Last Name is required";
      }],
      wholeNameRules: [function (v) {
        return !!v || "Name is required";
      }],
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
        );
      }],
      passwordRules: [function (v) {
        return !!v || "Password is required";
      }],
      prcNumberRules: [function (v) {
        return !!v || "PRC Number is required";
      }],
      mcrNumberRules: [function (v) {
        return !!v || "MCR Number is required";
      }],
      icNumberRules: [function (v) {
        return !!v || "IC Number is required";
      }],
      prcRegistrationDateRules: [function (v) {
        return !!v || "This field is required";
      }],
      prcValidityRules: [function (v) {
        return !!v || "This field is required";
      }],
      agreePolicy: false,
      agreePolicyRules: [function (v) {
        return !!v || "You must agree to continue! Please check details if all are correct.";
      }],
      agreeToNotify: true,
      notifyToEmail: true,
      notifyToMobile: false,
      submitbutton: true,

      specialization: "",
      specialtyList: [{ label: "Anesthesiology", value: "Anesthesiology" }, { label: "Dermatology", value: "Dermatology" }, { label: "Cardiology", value: "Cardiology" }, { label: "Endocrinology", value: "Endocrinology" }, { label: "Emergency Medicine", value: "Emergency Medicine" }, { label: "Family Medicine", value: "Family Medicine" }, { label: "GP", value: "gp" }, { label: "Internal Medicine", value: "Internal Medicine" }, { label: "Neurology", value: "Neurology" }, {
        label: "Obstetrics and Gynecology",
        value: "Obstetrics and Gynecology"
      }, { label: "Occupational Medicine", value: "Occupational Medicine" }, { label: "Otolaryngology", value: "Otolaryngology" }, { label: "Ophthalmology", value: "Ophthalmology" }, { label: "Pathology", value: "Pathology" }, { label: "Pediatrics", value: "Pediatrics" }, { label: "Psychiatry", value: "Psychiatry" }, { label: "Radiology", value: "Radiology" }, { label: "Surgery", value: "Surgery" }, { label: "Others", value: "Others" }],
      countries: [{ label: "Philippines", value: "Philippines" }],
      country: { label: "Philippines", value: "Philippines" }
    };
  },

  watch: {
    notifyToMobile: function notifyToMobile(val) {
      if (val) {}
    }
  },
  methods: {
    showPrivacyPolicyDialog: function showPrivacyPolicyDialog() {
      this.privacyPolicyDialog = true;
    },
    submit: function submit(e) {
      this.submitForm();
    },
    submitForm: function submitForm() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var data = {
          firstname: this.firstName,
          lastname: this.lastName,
          middlename: this.middleName,
          nickname: this.nickname,
          birthdate: this.birthday,
          email: this.emailAddress,
          password: this.password,
          // phone_numbers: [
          //   {
          //     type: 'primary contact number',
          //     number: this.primaryContactNumber
          //   },
          //   {
          //     type: 'secondary contact number',
          //     number: this.secondaryContactNumber
          //   },
          //   {
          //     type: 'other contact number',
          //     number: this.otherContactDetails
          //   }
          // ],
          phone_numbers: [{
            type: "primary contact number",
            number: this.mobileNumberInputField
          }],
          prc_number: this.prcNumber,
          registration_date: this.prcRegistrationDate,
          valid_until: this.prcValidity,
          notify_to_email: this.notifyToEmail,
          notify_to_mobile: this.notifyToMobile,
          specialty: this.specialization,
          country: this.country,
          name: this.wholeName,
          mcr_number: this.mcrNumber,
          ic_number: this.icNumber
        };
        var formData = new FormData();
        for (var prop in data) {
          if (Array.isArray(data[prop])) {
            data[prop].map(function (obj) {
              formData.append(prop + "[]", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            });
          } else {
            formData.set("" + prop, "" + data[prop]);
          }
        }
        this.submitbutton = false;
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(API_URL + "/user/registration", formData).then(function (e) {
          _this.notification();
          // this.$router.push('/login')
          _this.submitbutton = true;
          _this.$refs.form.reset();
        }).catch(function (e) {
          _this.text = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e.response.data);
          _this.text = "email has already been taken";
          _this.snackbar = true;
          _this.submitbutton = true;
        });
      }
    },
    notification: function notification() {
      this.text = "A message has been sent to your email to verify your registration";
      // this.snackbar = true
      this.notificationResponse = true;
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacyPolicy_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6624f65a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacyPolicy_vue__ = __webpack_require__(316);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6624f65a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    agreePolicy: Boolean,
    agreePolicyRules: Array
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      contactUsDialog: false,
      logo: __webpack_require__(11)
    };
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__configApi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_token__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var API_URL = __WEBPACK_IMPORTED_MODULE_2__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pw: true,
      logo: __webpack_require__(323),
      bg: __webpack_require__(66),

      username: '',
      password: '',

      usernameRules: [function (v) {
        return !!v || 'Username is required.';
      }],
      passwordRules: [function (v) {
        return !!v || 'Password is required.';
      }],

      color: 'error',
      text: '',
      snackbar: false,
      validForm: true,
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      resetPasswordForm: true,
      dialogresetForm: false,
      dialogResendVerification: false,
      email: '',
      enableVerificationButton: false,
      email_verify: '',
      resendVerificationForm: true
    };
  },

  methods: {
    submit: function submit(e) {
      var _this = this;

      if (e.shiftKey === true) {
        this.$router.push('/dashboard');
      } else {
        if (this.$refs.form.validate()) {
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(API_URL + '/login', {
            email: this.username,
            password: this.password,
            remember: false
          }).then(function (e) {
            // store token to session
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_token__["e" /* setAuthToken */])(e.data.access_token);
            // store user information
            _this.setSessionUser();
          }).catch(function (error) {
            if (error.response.data.error === 'invalid_authorization') {
              _this.enableVerificationButton = true;
            }
            _this.text = error.response.data.message;
            _this.snackbar = true;
          });
        }
      }
    },
    onClickResendVerification: function onClickResendVerification() {
      var _this2 = this;

      if (this.$refs.resendVerificationForm.validate()) {
        this.resendVerificationForm = false;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(API_URL + '/resend/verificationToken', {
          email: this.email_verify
        }).then(function (response) {
          _this2.text = response.data.message;
          _this2.snackbar = true;
          _this2.resendVerificationForm = true;
        }).catch(function (error) {
          _this2.text = error.response.data.message;
          _this2.snackbar = true;
          _this2.resendVerificationForm = true;
        });
      }
    },
    onClickVerification: function onClickVerification() {
      this.dialogResendVerification = true;
    },
    setSessionUser: function setSessionUser() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(API_URL + '/user').then(function (res) {
        localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        sessionStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        _this3.$router.push('/dashboard');
      }).catch(function (error) {
        console.log(error);
      });
    },
    openResetPasswordDialog: function openResetPasswordDialog() {
      this.dialogresetForm = true;
    },
    onClickPasswordReset: function onClickPasswordReset() {
      if (this.$refs.resetPasswordForm.validate()) {
        this.resetPasswordForm = false;
        this.sendPasswordRequest();
      }
    },
    sendPasswordRequest: function sendPasswordRequest() {
      var _this4 = this;

      var url = API_URL + '/password/email';
      var data = {
        email: this.email
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data).then(function (response) {
        _this4.text = 'Please check your email!';
        _this4.snackbar = true;
        _this4.dialogresetForm = false;
        _this4.resetPasswordForm = true;
      }).catch(function (error) {
        _this4.text = error.response.data.message;
        _this4.snackbar = true;
        _this4.resetPasswordForm = true;
      });
    }
  },
  props: {
    serverData: {
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profile_profileHeader__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_registration__ = __webpack_require__(328);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProfileHeader: __WEBPACK_IMPORTED_MODULE_0__components_profile_profileHeader__["a" /* default */],
    Registration: __WEBPACK_IMPORTED_MODULE_1__components_registration__["a" /* default */]
  },
  data: function data() {
    return {
      bg: __webpack_require__(7)
    };
  },

  props: {
    apiUrl: String
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imgHeight: 128,
      logo: __webpack_require__(11)
    };
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profile_privacyPolicy__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_token__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__configApi__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var apiUrl = __WEBPACK_IMPORTED_MODULE_5__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PrivacyPolicy: __WEBPACK_IMPORTED_MODULE_3__components_profile_privacyPolicy__["a" /* default */]
  },
  computed: {
    user: function user() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_token__["d" /* getUser */])();
    }
  },
  beforeMount: function beforeMount() {
    this.setInputValues();
  },
  data: function data() {
    return {
      formValid: true,
      firstName: '',
      lastName: '',
      middleName: '',
      nickname: '',
      birthday: '',
      primaryContactNumber: '',
      secondaryContactNumber: '',
      emailAddress: '',
      password: '',
      otherContactDetails: '',
      prcNumber: '',
      prcRegistrationDate: '',
      prcValidity: '',
      agreePolicy: false,

      firstNameRules: [function (v) {
        return !!v || 'First Name is required';
      }],
      lastNameRules: [function (v) {
        return !!v || 'Last Name is required';
      }],
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }],
      prcNumberRules: [function (v) {
        return !!v || 'PRC Number is required';
      }],
      prcRegistrationDateRules: [function (v) {
        return !!v || 'This field is required';
      }],
      prcValidityRules: [function (v) {
        return !!v || 'This field is required';
      }],
      agreePolicyRules: [function (v) {
        return !!v || 'You must agree to continue! Please check details if all are correct.';
      }],
      specialization: '',
      specialtyList: [{ label: 'Endocrinologist', value: 'Endocrinologist' }, { label: 'Diabetologist', value: 'Diabetologist' }, { label: 'Internist', value: 'Internist' }, { label: 'Cardiologist', value: 'Cardiologist' }, { label: 'General Physician', value: 'General Physician' }, { label: 'Family Medicine', value: 'Family Medicine' }, { label: 'Others', value: 'Others' }],
      text: '',
      snackbar: false
    };
  },

  methods: {
    pickFile: function pickFile() {
      this.$refs.inputFile.click();
    },
    onFilePicked: function onFilePicked(e) {
      var _this = this;

      var file = void 0;
      for (var x = 0, xlen = e.target.files.length; x < xlen; x++) {
        file = e.target.files[x];
        if (file.type.indexOf('image') !== -1) {
          var reader = new FileReader();

          reader.onload = function (e) {
            var img = new Image();
            img.src = e.target.result;
            _this.$refs.photo.src = img.src;
          };

          reader.readAsDataURL(file);
        }
      }
    },
    submit: function submit(e) {
      // if (e.shiftKey === true) {
      // this.$router.push('/dashboard')
      // } else {
      this.submitForm();
      // }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        var data = {
          firstname: this.firstName,
          lastname: this.lastName,
          middlename: this.middleName,
          nickname: this.nickname,
          // birthdate: this.birthday,
          email: this.emailAddress,
          password: this.password,
          // phone_numbers: [
          //   {
          //     type: 'primary contact number',
          //     number: this.primaryContactNumber
          //   },
          //   {
          //     type: 'secondary contact number',
          //     number: this.secondaryContactNumber
          //   },
          //   {
          //     type: 'other contact number',
          //     number: this.otherContactDetails
          //   }
          // ],
          prc_number: this.prcNumber,
          registration_date: this.prcRegistrationDate,
          valid_until: this.prcValidity,
          specialty: this.specialization
        };
        var formData = new FormData();
        if (this.$refs.inputFile.files.length > 0) {
          formData.append('photo', this.$refs.inputFile.files[0]);
        }
        for (var prop in data) {
          if (Array.isArray(data[prop])) {
            data[prop].map(function (obj) {
              formData.append(prop + '[]', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj));
            });
          } else {
            formData.set('' + prop, '' + data[prop]);
          }
        }
        this.formValid = false;
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(apiUrl + '/profile/' + this.user.id, formData).then(function (res) {
          _this2.text = 'Saved Successfully!';
          _this2.snackbar = true;
          _this2.formValid = true;
          _this2.setUserSession(res);
        }).catch(function (e) {
          _this2.text = e.response.data.message;
          _this2.formValid = true;
        });
      }
    },
    setUserSession: function setUserSession(res) {
      localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.data));
      sessionStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.data));
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    parseNumber: function parseNumber() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.user.user_phone_numbers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var number = _step.value;

          if (number.type === 'primary contact number') {
            this.primaryContactNumber = number.number;
          }
          if (number.type === 'secondary contact number') {
            this.secondaryContactNumber = number.number;
          }
          if (number.type === 'other contact number') {
            this.otherContactDetails = number.number;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    setInputValues: function setInputValues() {
      this.lastName = this.user.lastname;
      this.firstName = this.user.firstname;
      this.middleName = this.user.middlename;
      this.birthday = this.user.birthdate;
      this.emailAddress = this.user.email;
      this.prcNumber = this.user.user_license_numbers.prc_number;
      this.prcRegistrationDate = this.user.user_license_numbers.registration_date;
      this.prcValidity = this.user.user_license_numbers.valid_until;
      this.specialization = this.user.specialty;
      this.parseNumber();
    }
  }
});

/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dashboard_dashboardHeader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mainFooter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_latestModules__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dashboard_allModules__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dashboard_activities__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dashboard_authors__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dashboard_aboutUs__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dashboard_webinar__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dashboard_webinar_links__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_token__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__configApi__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import Watchlist from '@/components/dashboard/watchlist'






var apiUrl = __WEBPACK_IMPORTED_MODULE_13__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_3__components_dashboard_dashboardHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_4__components_mainFooter__["a" /* default */],
    AllModules: __WEBPACK_IMPORTED_MODULE_6__components_dashboard_allModules__["a" /* default */],
    LatestModules: __WEBPACK_IMPORTED_MODULE_5__components_dashboard_latestModules__["a" /* default */],
    Activities: __WEBPACK_IMPORTED_MODULE_7__components_dashboard_activities__["a" /* default */],
    Authors: __WEBPACK_IMPORTED_MODULE_8__components_dashboard_authors__["a" /* default */]
  },
  // created () {
  //   this.token = JSON.parse(localStorage.getItem('token'))
  //   // if (!this.token) {
  //   //   this.$router.push('/')
  //   // } else {
  //   //   this.fetchData()
  //   // }
  // },
  computed: {
    totalCpdPoints: function totalCpdPoints() {
      return this.user.user_points ? this.user.user_points.points : 0;
    },
    moduleData: function moduleData() {
      return this.modules;
    },
    dateToday: function dateToday() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('LL');
    }
  },
  data: function data() {
    return {
      doctorName: 'Who',
      logo: __webpack_require__(11),
      model: 'tab-about_us',
      tabs: [{
        text: 'About ELITE',
        value: 'about_us',
        component: __WEBPACK_IMPORTED_MODULE_9__components_dashboard_aboutUs__["a" /* default */]
      }, {
        text: 'About the Authors',
        value: 'authors',
        component: __WEBPACK_IMPORTED_MODULE_8__components_dashboard_authors__["a" /* default */]
      }, {
        text: 'All Modules',
        value: 'allModules',
        component: __WEBPACK_IMPORTED_MODULE_6__components_dashboard_allModules__["a" /* default */]
      }, {
        text: 'Latest Modules',
        value: 'latestModules',
        component: __WEBPACK_IMPORTED_MODULE_5__components_dashboard_latestModules__["a" /* default */]
      }, {
        text: 'Recorded Webinar',
        value: 'recorded_webinar',
        component: __WEBPACK_IMPORTED_MODULE_10__components_dashboard_webinar__["a" /* default */]
      }, {
        text: 'Thyroid Cheat Cards',
        value: 'webinar_links',
        component: __WEBPACK_IMPORTED_MODULE_11__components_dashboard_webinar_links__["a" /* default */]
      }, {
        text: 'My Activities',
        value: 'activities',
        component: __WEBPACK_IMPORTED_MODULE_7__components_dashboard_activities__["a" /* default */]
      }],
      token: null,
      modules: this.serverData.modules,
      user: Object(__WEBPACK_IMPORTED_MODULE_12__utils_token__["d" /* getUser */])(),
      activities: [],
      certificates: [],
      watchlist: [],
      userPoints: 0
    };
  },

  methods: {
    fetchData: function fetchData() {
      // this.getUserData()
      this.getActivities();
      this.getModules();
      this.getWatchlist();
      this.getPoints();
    },
    getPoints: function getPoints() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl + '/points/' + this.user.id).then(function (res) {
        if (res.data) {
          _this.userPoints = res.data.points;
        }
      });
    },
    getModules: function getModules() {
      var _this2 = this;

      if (navigator.onLine) {
        console.log('User is online - Fetching info from server');
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl + '/module').then(function (e) {
          if (e.data.length > 0) {
            _this2.$set(_this2, 'modules', e.data);
          }
        }).catch(function (e) {
          console.log('error', e);
        });
      } else {
        console.log('User is offline - Fetching info from localstorage');
      }
    },
    getActivities: function getActivities() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl + '/user').then(function (r) {
        var prop = 'module_id';
        var userAssessment = r.data.user_assessment.sort(function (a, b) {
          return a.created_at < b.created_at;
        }).filter(function (obj, pos, arr) {
          return arr.map(function (mapObj) {
            return mapObj[prop];
          }).indexOf(obj[prop]) === pos;
        });
        // let watchList = r.data.watch_list.sort((a, b) => a.created_at < b.created_at).filter((obj, pos, arr) => {
        //   return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
        // })
        _this3.activities = userAssessment;
        _this3.certificates = r.data.certificate;
      }).catch(function (e) {});
    },
    getWatchlist: function getWatchlist() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl + '/watchlist/' + this.user.id).then(function (res) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var watchmod = _step.value;

            _this4.watchlist.push(watchmod);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    addToWatchlist: function addToWatchlist(module) {
      var _this5 = this;

      var data = {
        user_id: this.user.id,
        module_id: module.id
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl + '/watchlist/' + this.user.id, data).then(function (res) {
        _this5.watchlist.push(res.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    removeToWatchList: function removeToWatchList(list) {
      var _this6 = this;

      var watchListIndex = this.watchlist.findIndex(function (i) {
        return i.id === list.id;
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl + '/watchlist/' + list.id + '/delete', {}).then(function (res) {
        _this6.watchlist.splice(watchListIndex, 1);
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  props: {
    apiUrl: String,
    serverData: {
      default: function _default() {
        return [];
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  }
});

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_token__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imgHeight: 128,
      logo: __webpack_require__(11)
    };
  },

  computed: {
    user: function user() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_token__["d" /* getUser */])();
    },
    token: function token() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_token__["c" /* getAuthToken */])();
    }
  },
  methods: {
    logout: function logout() {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_token__["b" /* deleteUser */])();
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_token__["a" /* deleteAuthToken */])();
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { getUser } from '@/utils/token'

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    dateToday: function dateToday() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('LL');
    },
    totalModules: function totalModules() {
      return this.modules.length || 0;
    },
    completedModules: function completedModules() {
      return this.user.user_assessment.filter(function (i) {
        return i.earned > 0;
      }).length || 0;
    }
  },
  data: function data() {
    return {
      bg: __webpack_require__(7),
      search: '',
      rowsPerPageItems: [6, 12, 18],
      pagination: {
        rowsPerPage: 5
      },
      latestModules: []
    };
  },

  methods: {
    handleClick: function handleClick(module) {
      this.$router.push('/module/' + module.id);
      this.addToWatchlist(module);
    },
    showMore: function showMore() {
      alert('show more programs');
    },
    onClickAddWatchList: function onClickAddWatchList(item) {
      this.addToWatchlist(item);
    },
    checkIfNotInWatchList: function checkIfNotInWatchList(item) {
      return this.watchlist.some(function (i) {
        return i.module_id === item.id;
      });
    },
    isAlreadyWatched: function isAlreadyWatched(item) {
      if (this.user.user_assessment) {
        var watched = this.user.user_assessment.some(function (u) {
          return Number(u.module_id) === Number(item.id);
        });
        return watched;
      }
    }
  },
  props: {
    user: {
      type: Object,
      default: function _default() {}
    },
    modules: {
      default: function _default() {
        return [];
      }
    },
    watchlist: {
      default: function _default() {
        return [];
      }
    },
    addToWatchlist: {
      type: Function
    }
  },
  watch: {
    modules: function modules(v) {
      this.latestModules = v;
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { getUser } from '@/utils/token'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(7),
      allModules: []
    };
  },

  methods: {
    handleClick: function handleClick(module) {
      this.$router.push('/module/' + module.id);
      this.addToWatchlist(module);
    },
    isAlreadyWatched: function isAlreadyWatched(item) {
      if (this.user.user_assessment) {
        var watched = this.user.user_assessment.some(function (u) {
          return Number(u.module_id) === Number(item.id);
        });
        return watched;
      }
    }
  },
  props: {
    user: {
      type: Object,
      default: function _default() {}
    },
    modules: {
      default: null
    },
    addToWatchlist: {
      type: Function
    }
  },
  watch: {
    modules: function modules(v) {
      this.allModules = v;
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    activitiesCount: function activitiesCount() {
      return this.filteredActivities.length;
    },
    dateToday: function dateToday() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('LL');
    },
    filteredActivities: function filteredActivities() {
      return this.activities.sort(function (a, b) {
        return a.created_at < b.created_at;
      });
    }
  },
  data: function data() {
    return {
      bg: __webpack_require__(7),
      search: ''
    };
  },

  methods: {
    handleClick: function handleClick(module) {
      this.$router.push('/module/' + module.id);
    },
    convertDate: function convertDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('LL');
    },
    onlyEarnedPoints: function onlyEarnedPoints(i) {
      return i.earned > 0;
    }
  },
  props: {
    user: {
      default: null
    },
    activities: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    certificates: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__server_lecturers__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__server_lecturers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__server_lecturers__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(7),
      authors: __WEBPACK_IMPORTED_MODULE_0__server_lecturers___default.a.items
    };
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(7)
    };
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__configApi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var apiUrl = __WEBPACK_IMPORTED_MODULE_2__configApi___default.a.apiUrl;
var filesUrl = __WEBPACK_IMPORTED_MODULE_2__configApi___default.a.filesUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(7),
      search: '',
      rowsPerPageItems: [3, 6, 12, 18],
      pagination: {
        rowsPerPage: 5
      },
      dialog: false,
      selectedWebinar: {},
      recordedWebinars: [],
      linkedWebinars: [],
      searchLinked: [],
      searchRecorded: [],
      filterTypes: ['All'],
      url: apiUrl.replace('api', ''),
      filesUrl: filesUrl,
      categoryText: ''
    };
  },

  components: {
    Media: __WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio___default.a
  },
  mounted: function mounted() {
    this.fetchData();
  },
  updated: function updated() {
    this.updateLog();
  },

  methods: {
    updateLog: function updateLog() {},
    handleFilter: function handleFilter(selected) {
      if (selected === 'All') {
        selected = '';
      }
      var data = this.linkedWebinars.filter(function (val) {
        return val.category ? val.category.toLowerCase().includes(selected.toLowerCase()) : [];
      });
      var recordedData = this.recordedWebinars.filter(function (val) {
        return val.category ? val.category.toLowerCase().includes(selected.toLowerCase()) : [];
      });
      this.searchRecorded = recordedData;
      this.searchLinked = data;
      this.search = '';
    },
    handleChange: function handleChange() {
      var search = this.search,
          recordedWebinars = this.recordedWebinars;

      var data = recordedWebinars.filter(function (val) {
        return val.title ? val.title.toLowerCase().includes(search.toLowerCase()) : [];
      });
      this.searchLinked = data;
      this.searchRecorded = data;
      this.categoryText = '';
    },
    fetchData: function fetchData() {
      this.getWebinar();
    },
    convertDate: function convertDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('LL');
    },
    getWebinar: function getWebinar() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl + '/webinar').then(function (res) {
        _this.recordedWebinars = res ? res.data.filter(function (val) {
          return val.is_recorded === 1;
        }) : [];
        _this.linkedWebinars = res ? res.data.filter(function (val) {
          return val.is_recorded === 0;
        }) : [];
        _this.searchLinked = _this.linkedWebinars;
        _this.searchRecorded = _this.recordedWebinars;

        _this.searchLinked.map(function (row) {
          if (!_this.filterTypes.includes(row.category)) {
            _this.filterTypes.push(row.category);
          }
        });
        _this.searchRecorded.map(function (row) {
          if (!_this.filterTypes.includes(row.category)) {
            _this.filterTypes.push(row.category);
          }
        });
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    handleClick: function handleClick(webinar) {
      this.dialog = true;
      this.selectedWebinar = webinar;
    }
  }
});

/***/ }),
/* 218 */,
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__configApi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var apiUrl = __WEBPACK_IMPORTED_MODULE_2__configApi___default.a.apiUrl;
var filesUrl = __WEBPACK_IMPORTED_MODULE_2__configApi___default.a.filesUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bg: __webpack_require__(7),
      search: "",
      rowsPerPageItems: [3, 6, 12, 18],
      pagination: {
        rowsPerPage: 5
      },
      dialog: false,
      selectedWebinar: {},
      recordedWebinars: [],
      linkedWebinars: [{
        title: "Goiter and Nodule",
        url: "https://bit.ly/GoiterandNodule",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Hyperthyroidism",
        url: "https://bit.ly/elitehyperthyroidism",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Hypothyroidism",
        url: "https://bit.ly/elitehypothyroidism",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Subclinical Hypothyroidism",
        url: "https://bit.ly/elitesubclinicalhypothyroidism",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Thyroid Disorders in Pregnancy",
        url: "https://bit.ly/thyroidinpregnancy",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }],
      searchLinked: [{
        title: "Goiter and Module",
        url: "/static/pptx/GoiterandNodule.pptx",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Hyperthyroidism",
        url: "/static/pptx/Hyperthyroidism.pptx",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Hypothyroidism",
        url: "/static/pptx/Hypothyroidism.pptx",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Subclinical Hypothyroidism",
        url: "/static/pptx/SubclinicalHypothyroidism.pptx",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }, {
        title: "Thyroid Disorders in Pregnancy",
        url: "/static/pptx/ThyroidDisordersinPregnancy.pptx",
        image: "",
        category: "",
        created_at: "2024-07-05"
      }],
      searchRecorded: [],
      filterTypes: ["All"],
      url: apiUrl.replace("api", ""),
      filesUrl: filesUrl,
      categoryText: ""
    };
  },

  components: {
    Media: __WEBPACK_IMPORTED_MODULE_0__dongido_vue_viaudio___default.a
  },
  mounted: function mounted() {
    this.fetchData();
  },
  updated: function updated() {
    this.updateLog();
  },

  methods: {
    downloadPDF: function downloadPDF(url, title) {
      // Reference to the PDF file in the public folder
      var pdfUrl = url; // BASE_URL automatically points to /public folder in Vue

      // Create a temporary anchor element
      var downloadLink = document.createElement("a");
      downloadLink.href = pdfUrl;
      downloadLink.download = title + ".pdf"; // The name of the downloaded file

      // Append the link to the DOM, trigger the click and remove it from the DOM
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    updateLog: function updateLog() {},

    // handleFilter(selected) {
    //   if (selected === "All") {
    //     selected = "";
    //   }
    //   let data = this.linkedWebinars.filter((val) =>
    //     val.category
    //       ? val.category.toLowerCase().includes(selected.toLowerCase())
    //       : []
    //   );
    //   let recordedData = this.recordedWebinars.filter((val) =>
    //     val.category
    //       ? val.category.toLowerCase().includes(selected.toLowerCase())
    //       : []
    //   );
    //   this.searchRecorded = recordedData;
    //   this.searchLinked = data;
    //   this.search = "";
    // },
    // handleChange() {
    //   let { search, linkedWebinars } = this;
    //   let data = linkedWebinars.filter((val) =>
    //     val.title ? val.title.toLowerCase().includes(search.toLowerCase()) : []
    //   );
    //   this.searchLinked = data;
    //   this.categoryText = "";
    // },
    fetchData: function fetchData() {
      this.getWebinar();
    },
    convertDate: function convertDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("LL");
    },
    getWebinar: function getWebinar() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl + "/webinar").then(function (res) {
        _this.recordedWebinars = res ? res.data.filter(function (val) {
          return val.is_recorded === 1;
        }) : [];
        // this.linkedWebinars = res
        //   ? res.data.filter((val) => val.is_recorded === 0)
        //   : this.linkedWebinars;
        // this.searchLinked = this.linkedWebinars;
        _this.searchRecorded = _this.recordedWebinars;

        _this.searchLinked.map(function (row) {
          if (!_this.filterTypes.includes(row.category)) {
            _this.filterTypes.push(row.category);
          }
        });
        _this.searchRecorded.map(function (row) {
          if (!_this.filterTypes.includes(row.category)) {
            _this.filterTypes.push(row.category);
          }
        });
      }).catch(function (e) {
        console.log("error", e);
      });
    },
    handleClick: function handleClick(webinar) {
      this.dialog = true;
      this.selectedWebinar = webinar;
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard_dashboardHeader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mainFooter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_module_messagingFeature__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_module_relatedModules__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var apiUrl = __WEBPACK_IMPORTED_MODULE_5__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_0__components_dashboard_dashboardHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_1__components_mainFooter__["a" /* default */],
    MessagingFeature: __WEBPACK_IMPORTED_MODULE_2__components_module_messagingFeature__["a" /* default */],
    RelatedModules: __WEBPACK_IMPORTED_MODULE_3__components_module_relatedModules__["a" /* default */]
  },
  computed: {
    doctorName: function doctorName() {
      return this.user ? this.user.nickname : '';
    }
  },
  created: function created() {
    this.fetchData();
  },

  data: function data() {
    return {
      videoPaused: true,
      vTime: 0,
      segmentWatched: 0,
      proceedToExam: false,
      slides: [{
        title: 'Start',
        desc: '',
        start_time: 0,
        end_time: 20,
        watched: false
      }],
      moduleId: parseInt(this.$route.params.id),
      ratingIconOn: __webpack_require__(26),
      ratingIconOff: __webpack_require__(362),
      token: null,
      user: {},
      moduleData: {},
      percentageViewed: 0
    };
  },
  methods: {
    goToExam: function goToExam() {
      this.$router.push('/module/' + this.moduleId + '/assessment');
    },
    fetchData: function fetchData() {
      this.getModule();
    },
    getModule: function getModule() {
      var _this = this;

      if (navigator.onLine) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(apiUrl + '/module/' + this.moduleId).then(function (e) {
          console.log(e.data);
          if (e.data) {
            _this.moduleData = e.data;
            console.log('module/index.vue', _this.moduleData);
            if (_this.moduleData.segments.length > 0) {
              _this.slides = _this.moduleData.segments;
            }
          }
        }).catch(function (e) {
          console.log('error', e);
        });
      } else {}
    },
    handleVideoClick: function handleVideoClick() {
      if (this.$refs.video.paused) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
      this.$set(this, 'videoPaused', this.$refs.video.paused);
    },
    handleClickFullscreen: function handleClickFullscreen() {
      this.handleFullScreen(this.$refs.video);
    },
    handleFullScreen: function handleFullScreen(doc) {
      if (doc.fullscreen || doc.webkitIsFullScreen || doc.mozFullScreen || doc.msFullscreenElement) {
        this.exitFullscreen(doc);
      } else {
        this.requestFullScreen(doc);
      }
    },
    requestFullScreen: function requestFullScreen(docElm) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    },
    fullscreenchange: function fullscreenchange(document) {
      document.addEventListener('fullscreenchange', function () {
        document.fullscreen = document.fullscreen ? '' : 'not ';
      }, false);

      document.addEventListener('mozfullscreenchange', function () {
        document.mozFullScreen = document.mozFullScreen ? '' : 'not ';
      }, false);

      document.addEventListener('webkitfullscreenchange', function () {
        document.webkitIsFullScreen = document.webkitIsFullScreen ? '' : 'not ';
      }, false);

      document.addEventListener('msfullscreenchange', function () {
        document.msFullscreenElement = document.msFullscreenElement ? '' : 'not ';
      }, false);
    },
    exitFullscreen: function exitFullscreen(document) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    goTo: function goTo(timeframe) {
      this.$refs.video.currentTime = timeframe;
      if (this.$refs.video.paused) {
        this.$refs.video.play();
      }
      this.$set(this, 'videoPaused', this.$refs.video.paused);
    },
    checkWatchedVideo: function checkWatchedVideo(vTime) {
      var _this2 = this;

      this.slides.find(function (value, index) {
        if (vTime >= Number(value.start_time) && vTime <= Number(value.end_time)) {
          console.log('vtime', vTime);
          console.log('module_time', value.start_time + ' ' + value.end_time);
          // console.log(((vTime - Number(value.start_time)) / (Number(value.end_time) - Number(value.start_time))))
          _this2.$set(_this2, 'percentageViewed', (vTime - Number(value.start_time)) / (Number(value.end_time) - Number(value.start_time)) * 100);
          if (_this2.percentageViewed >= 80) {
            _this2.$set(value, 'watched', true);
          }
        }
      });
      this.$set(this, 'segmentWatched', this.slides.filter(function (i) {
        return i.watched === true;
      }).length);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$refs.video.onerror = function (err) {
      console.log(err);
    };
    this.$refs.video.onended = function (a) {
      if (_this3.moduleData.questionnaire.length > 0) {
        if (_this3.segmentWatched >= _this3.slides.length) {
          _this3.goToExam();
        }
      } else {
        _this3.$router.push('/dashboard');
      }
    };
    this.$refs.video.addEventListener('timeupdate', function (e) {
      _this3.$set(_this3, 'vTime', e.target.currentTime);
    }, false);
  },

  props: {
    serverData: {
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    segmentWatched: function segmentWatched(n) {
      if (n >= this.slides.length) {
        this.proceedToExam = true;
      }
    },
    slides: function slides() {},
    vTime: function vTime(_vTime) {
      this.checkWatchedVideo(_vTime);
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      messageToAuthor: '',
      items: [{ header: 'Comments' }, { initials: 'A', avatar: __webpack_require__(26), title: 'Brunch this weekend?', subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?" }, { divider: true, inset: true }, { initials: 'F', avatar: __webpack_require__(26), title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>', subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend." }, { divider: true, inset: true }, { initials: 'K', avatar: __webpack_require__(26), title: 'Oui oui', subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?" }]
    };
  },

  methods: {
    showMessaging: function showMessaging() {
      this.dialog = true;
    },
    submitMessage: function submitMessage() {
      alert('Message Sent!');
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    relatedModules: function relatedModules() {
      return this.serverData.modules;
    }
  },
  created: function created() {
    // this.fetchData()
  },
  data: function data() {
    return {
      modules: []
    };
  },

  methods: {
    handleClick: function handleClick(moduleId) {
      console.log(moduleId);
      this.$router.push('/module/' + moduleId);
    },
    fetchData: function fetchData() {
      if (navigator.onLine) {
        console.log('User is online - Fetching tag information from server');
        localStorage.setItem('modules', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.modules));
      } else {
        console.log('User is offline - Fetching tag information from localstorage');
        this.$set(this, 'modules', JSON.parse(localStorage.getItem('modules')));
      }
      // console.log('items: ' + JSON.stringify(this.items))
    }
  },
  props: {
    serverData: {
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dashboard_dashboardHeader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mainFooter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_module_assessment_assessmentResult__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_token__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__configApi__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var apiUrl = __WEBPACK_IMPORTED_MODULE_6__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_1__components_dashboard_dashboardHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_2__components_mainFooter__["a" /* default */],
    AssessmentResult: __WEBPACK_IMPORTED_MODULE_3__components_module_assessment_assessmentResult__["a" /* default */]
  },
  created: function created() {
    this.fetchData();
  },

  computed: {
    questionsLength: function questionsLength() {
      return this.selectedQuestions.length;
    },
    selectedQuestions: function selectedQuestions() {
      return this.shuffle(this.questions).slice(0, 5);
    }
  },
  data: function data() {
    return {
      e1: 1,
      bg: __webpack_require__(367),
      dialog: false,
      certificateCode: "",
      radioGroup: [],
      user: Object(__WEBPACK_IMPORTED_MODULE_5__utils_token__["d" /* getUser */])(),
      moduleId: this.$route.params.id,
      module: {},
      questions: this.serverData.questions,
      steps: this.serverData.questions.length,
      score: 0,
      minimum: 2,
      points: 0,
      completion: 0,
      totalModule: 0,
      validAnswer: 0
    };
  },

  methods: {
    shuffle: function shuffle(array) {
      var currentIndex = array.length;
      var temporaryValue;
      var randomIndex;

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    getValue: function getValue(id) {
      return String(id);
    },
    retry: function retry() {
      this.$set(this, "dialog", false);
      this.e1 = 1;
    },
    reviewModule: function reviewModule() {
      this.$set(this, "dialog", false);
      this.$router.push("/module/" + this.moduleId);
    },
    nextStep: function nextStep(n, activeKey) {
      this.score = Number(this.score) + Number(this.radioGroup[activeKey].value);

      if (n === this.steps) {
        if (this.score >= this.module.minimum_score) {
          this.points = this.module.cpd_points;
        }
        this.onSubmit();
        // this.dialog = true
      } else {
        if (this.radioGroup[activeKey].value === "1") {
          this.e1 = n + 1;
          this.validAnswer = 0;
        } else {
          this.validAnswer = n;
        }
      }
    },
    onSubmit: function onSubmit() {
      var self = this;
      var data = {
        user_id: this.user.id,
        module_id: this.$route.params.id,
        score: this.score
      };
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(apiUrl + "/assessment", data).then(function (r) {
        self.certificateCode = r.data.certificate ? String(r.data.certificate.code) : "";
        self.totalModule = r.data.module_count;
        self.completion = r.data.completion;
        self.setSessionUser();
        self.dialog = true;
      }).catch(function (e) {});
    },
    getChoices: function getChoices(questionId) {
      return this.questions.filter(function (v) {
        return v.id === questionId;
      }).choices;
    },
    fetchData: function fetchData() {
      this.getModule();
    },
    getModule: function getModule() {
      var _this = this;

      if (navigator.onLine) {
        console.log("User is online - Fetching info from server");
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(apiUrl + "/module/" + this.moduleId).then(function (e) {
          // console.log(e.data)
          _this.$set(_this, "module", e.data);
        }).catch(function (e) {
          console.log("error", e);
        });
      } else {
        console.log("User is offline - Fetching info from localstorage");
      }
    },
    setSessionUser: function setSessionUser() {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(apiUrl + "/user").then(function (res) {
        localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        sessionStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        // this.$router.push('/dashboard')
      }).catch(function (error) {
        console.log(error);
      });
    },
    parseNumber: function parseNumber(str) {
      return Number(str);
    }
  },
  props: {
    serverData: {
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    dialog: function dialog(v) {
      if (v === false) {
        this.score = 0;
        this.e1 = 1;
        this.radioGroup = [];
      }
    },
    module: function module(v) {
      this.questions = v.questionnaire;
    },
    selectedQuestions: function selectedQuestions(v) {
      this.$set(this, "steps", v.length);
    },
    steps: function steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pointsColor: this.points > 0 ? 'accent' : 'error'
    };
  },

  props: {
    certificateCode: String,
    score: {
      default: 0
    },
    total: {
      default: 0
    },
    points: {
      default: 2.3
    },
    retry: {
      type: Function
    },
    reviewModule: {
      type: Function
    },
    minimum: Number,
    completion: Number,
    totalModule: Number
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dashboard_dashboardHeader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mainFooter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as jsPDF from 'jsPDF'







var apiUrl = __WEBPACK_IMPORTED_MODULE_4__configApi___default.a.apiUrl;

/* global FB */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_2__components_dashboard_dashboardHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_3__components_mainFooter__["a" /* default */]
  },
  computed: {
    formattedCertificateTaken: function formattedCertificateTaken() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.certificateCreated).format('LL');
    },
    dateToday: function dateToday() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL');
    }
  },
  created: function created() {
    // this.getCertificateData(this.certificateCode)
  },
  mounted: function mounted() {
    this.getCertificateData(this.certificateCode);
  },
  data: function data() {
    return {
      certificateCode: this.$route.params.code,
      logo: __webpack_require__(11),
      merckLogo: __webpack_require__(372),
      bg: __webpack_require__(373),
      user: {
        firstname: 'Juan',
        middlename: 'Dela',
        lastname: 'Cruz'
      },
      moduleId: 1,
      moduleTitle: 'Expert Case Studies in Peripheral T-Cell Lymphoma',
      refNumber: {
        5: 'MED-2018-266-3146',
        4: 'MED-2018-266-3151',
        3: 'MED-2018-266-3148',
        2: 'MED-2018-266-2472',
        1: 'MED-2018-266-3152',
        6: 'MED-2018-266-2475',
        9: 'MED-2018-266-2477',
        10: 'MED-2018-266-3147',
        8: 'MED-2018-266-3149',
        7: 'MED-2018-266-2490'
      },
      moduleCodes: "",
      cpdPoints: 1,
      certificateCreated: '2018-12-19 00:00:00',
      styles: {
        text: {
          fontSize: '1.5rem',
          lineHeight: '2.5em'
        }
      }
    };
  },

  methods: {
    getCertificateData: function getCertificateData(certCode) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + '/certificate/' + certCode).then(function (r) {
        console.log(r.data);
        _this.user.firstname = r.data.user.firstname ? r.data.user.firstname : '';
        _this.user.middlename = r.data.user.middlename ? r.data.user.middlename : '';
        _this.user.lastname = r.data.user.lastname ? r.data.user.lastname : '';
        // this.moduleTitle = 'Thyroid Disease Management'
        _this.moduleTitle = r.data.module.title;
        _this.moduleCodes = r.data.module.codes;
        _this.cpdPoints = 1;
        _this.moduleId = r.data.module.id;
        // this.cpdPoints = r.data.module.cpd_points
        _this.certificateCreated = r.data.created_at;
      }).catch(function (e) {});
    },
    handleSaveAsPdf: function handleSaveAsPdf() {
      window.print();
      // Default export is a4 paper, portrait, using milimeters for units
      // var doc = jsPDF()

      // doc.addPage()

      // doc.setFontSize(40)
      // doc.text('Certificate of Completion', 10, 40)

      // doc.save('a4.pdf')
    },
    dateToday: function dateToday() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL');
    },
    initiateFacebook: function initiateFacebook() {
      window.fbAsyncInit = function () {
        FB.init({
          appId: '233247144074617',
          xfbml: true,
          version: 'v3.0'
        });
        FB.AppEvents.logPageView();
      };

      (function (d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    },
    shareToFb: function shareToFb() {
      // FB.ui(
      //   {
      //     method: 'share_open_graph',
      //     action_type: 'og.likes',
      //     action_properties: JSON.stringify({
      //       object: `https://merck.medix.ph`
      //     })
      //   },
      //   // callback
      //   function (response) {
      //     if (response && !response.error_message) {
      //       alert('Posting completed.')
      //     } else {
      //       console.log('Error while posting.')
      //     }
      //   }
      // )
      var urlLink = location.origin + '/#/certificate/' + this.certificateCode;
      FB.ui({
        method: 'feed',
        link: urlLink,
        caption: 'sample test'
      }, function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.initiateFacebook();
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard_dashboardHeader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_author_teofilo__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_author_kho__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_author_nicodemus__ = __webpack_require__(382);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_0__components_dashboard_dashboardHeader__["a" /* default */],
    Teofilo: __WEBPACK_IMPORTED_MODULE_1__components_author_teofilo__["a" /* default */],
    Kho: __WEBPACK_IMPORTED_MODULE_2__components_author_kho__["a" /* default */],
    Nicodemus: __WEBPACK_IMPORTED_MODULE_3__components_author_nicodemus__["a" /* default */]
  },
  created: function created() {
    if (this.author_id === 'teofilo') {
      this.author = __WEBPACK_IMPORTED_MODULE_1__components_author_teofilo__["a" /* default */];
    }
    if (this.author_id === 'kho') {
      this.author = __WEBPACK_IMPORTED_MODULE_2__components_author_kho__["a" /* default */];
    }
    if (this.author_id === 'nicodemus') {
      this.author = __WEBPACK_IMPORTED_MODULE_3__components_author_nicodemus__["a" /* default */];
    }
  },
  data: function data() {
    return {
      author_id: this.$route.params.name
    };
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      author: __webpack_require__(377)
    };
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      author: __webpack_require__(380)
    };
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      author: __webpack_require__(383)
    };
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_module_addModuleForm__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_json_csv__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_3_vue_json_csv___default.a);

var apiUrl = __WEBPACK_IMPORTED_MODULE_4__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddModuleForm: __WEBPACK_IMPORTED_MODULE_1__components_admin_module_addModuleForm__["a" /* default */]
  },
  created: function created() {
    this.token = localStorage.getItem('token');
  },
  data: function data() {
    return {
      onLoading: false,
      modules: [],
      submitData: {
        title: null,
        description: null,
        category: null,
        is_recorded: 0,
        url: null,
        image: null,
        video: null
      },
      errorMessage: null,
      hasError: false,
      dialogFormModule: false,
      token: null,
      dialogWebinar: false,
      csvData: {
        userData: [],
        certData: [],
        assessData: []
      },
      uFormModal: false,
      uEndModal: false,
      cStartModal: false,
      cEndModal: false,
      aStartModal: false,
      aEndModal: false,
      dateRange: {
        start: new Date().toISOString().substring(0, 10),
        end: new Date().toISOString().substring(0, 10)
      },
      title: 'Image Upload',
      imageName: '',
      imageUrl: '',
      imageFile: '',
      videoName: '',
      videoUrl: '',
      videoFile: '',
      isSaving: false
    };
  },

  methods: {
    generateData: function generateData(type) {
      var _this = this;

      var url = apiUrl + '/generate/users';
      var dataType = 'user';
      switch (type) {
        case 'assessment':
          url = apiUrl + '/generate/assessment';
          dataType = 'assessment';
          break;
        case 'certificate':
          url = apiUrl + '/generate/certificate';
          dataType = 'certificate';
          break;
        default:
          url = apiUrl + '/generate/users';

      }
      var params = {
        start: this.dateRange.start,
        end: this.dateRange.end
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, params).then(function (res) {
        if (res.status == 200) {
          switch (dataType) {
            case 'assessment':
              _this.csvData.assessData = res.data;
              _this.csvData.certData = [];
              _this.csvData.userData = [];
              break;
            case 'certificate':
              _this.csvData.certData = res.data;
              _this.csvData.assessData = [];
              _this.csvData.userData = [];
              break;
            default:
              _this.csvData.userData = res.data;
              _this.csvData.assessData = [];
              _this.csvData.certData = [];

          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    pickFileVideo: function pickFileVideo() {
      this.$refs.video.click();
    },
    onFilePicked: function onFilePicked(e) {
      var _this2 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", function () {
          _this2.imageUrl = fr.result;
          _this2.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    onFilePickedVideo: function onFilePickedVideo(e) {
      var _this3 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        this.videoName = files[0].name;
        if (this.videoName.lastIndexOf(".") <= 0) {
          return;
        }
        var fr = new FileReader();
        // fr.readAsDataURL(files[0]) // This reads a file and returns a Data URL referencing it. This is inefficient for large files as the file is loaded into memory as a whole before being processed
        fr.readAsArrayBuffer(files[0]); // This reads a file and returns an ArrayBuffer containing the input file 'chopped up in smaller pieces'. This works for very large files, too.
        fr.addEventListener("load", function () {

          // handle big file size of video
          var TYPED_ARRAY = new Uint8Array(fr.result);
          var STRING_CHAR = TYPED_ARRAY.reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, '');
          var base64String = btoa(STRING_CHAR);
          base64String = 'data:video/mp4;base64,' + base64String;

          _this3.videoUrl = base64String;
          // old setting
          // this.videoUrl = fr.result
          _this3.videoFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.videoName = "";
        this.videoFile = "";
        this.videoUrl = "";
      }
    },
    getModules: function getModules() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/module").then(function (res) {
        _this4.modules = res.data;
      });
    },
    handleSubmitWebinar: function handleSubmitWebinar() {
      var _this5 = this;

      var _submitData = this.submitData,
          title = _submitData.title,
          description = _submitData.description,
          category = _submitData.category,
          url = _submitData.url;

      if (title && description && category) {
        this.hasError = false;
      } else {
        this.hasError = true;
        return;
      }
      if (this.submitData.is_recorded === 1) {
        this.submitData.url = null;
      } else {
        if (url) {
          this.hasError = false;
        } else {
          this.hasError = true;
          return;
        }
      }
      this.isSaving = true;
      var data = { file: this.imageUrl };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/upload', data).then(function (res) {
        if (res.status === 200) {
          if (_this5.submitData.is_recorded === 1) {
            var data2 = { file: _this5.videoUrl };
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/uploadFile', data2).then(function (response) {
              if (response.status === 200) {
                _this5.submitData.image = res.data.url;
                _this5.submitData.video = response.data.url;
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/webinar', _this5.submitData).then(function (res) {
                  if (res.status === 201) {
                    _this5.dialogWebinar = false;
                    _this5.submitData.title = null;
                    _this5.submitData.category = null;
                    _this5.submitData.url = null;
                    _this5.submitData.description = null;
                    _this5.submitData.image = null;
                    _this5.submitData.video = null;
                    _this5.submitData.is_recorded = 0;
                    _this5.imageFile = "";
                    _this5.imageName = "";
                    _this5.imageUrl = "";
                    _this5.videoName = "";
                    _this5.videoUrl = "";
                    _this5.videoFile = "";
                    _this5.isSaving = false;
                  }
                }).catch(function (e) {
                  _this5.isSaving = false;
                  console.log("error", e);
                });
              }
            }).catch(function (error) {
              console.log("error", error);
              _this5.isSaving = false;
            });
          } else {
            _this5.submitData.image = res.data.url;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/webinar', _this5.submitData).then(function (res) {
              if (res.status === 201) {
                _this5.dialogWebinar = false;
                _this5.submitData.title = null;
                _this5.submitData.category = null;
                _this5.submitData.url = null;
                _this5.submitData.description = null;
                _this5.submitData.image = null;
                _this5.submitData.is_recorded = 0;
                _this5.imageFile = "";
                _this5.imageName = "";
                _this5.imageUrl = "";
                _this5.isSaving = false;
              }
            }).catch(function (e) {
              console.log("error", e);
            });
          }
        } else {
          console.log("Failed to upload");
          _this5.isSaving = false;
        }
      });
    },
    handleClick: function handleClick(moduleId) {
      this.$router.push("/admin/module/" + moduleId);
    },
    addToArray: function addToArray() {
      var obj = { question: "", answer: "" };
      this.multipleQuestions.push(obj);
    },
    removeToArray: function removeToArray(index) {
      console.log(index);
      // this.$delete(this.multipleQuestions, index)
    },
    updateMultiQuestions: function updateMultiQuestions(obj, index) {
      this.multipleQuestions[index] = obj;
    }
  },
  mounted: function mounted() {
    this.getModules();
  },

  props: {
    apiUrl: {
      type: String
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__configApi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_module_multipleSegment__ = __webpack_require__(388);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var apiUrl = __WEBPACK_IMPORTED_MODULE_2__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    multipleSegment: __WEBPACK_IMPORTED_MODULE_3__components_admin_module_multipleSegment__["a" /* default */]
  },
  created: function created() {
    this.token = localStorage.getItem('token');
    this.getUser();
  },
  data: function data() {
    return {
      token: null,
      author: null,
      video: null,
      image: null,
      cpdPoints: null,
      title: null,
      description: null,
      category: null,
      minimumScore: null,
      formValid: true,
      userId: null,
      segmentData: [{
        start_time: '',
        end_time: '',
        time: '',
        description: ''
      }]
    };
  },

  methods: {
    getUser: function getUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl + '/user').then(function (res) {
        _this.userId = res.data.id;
      });
    },
    pickVideoFile: function pickVideoFile() {
      this.$refs.inputVideoFile.click();
    },
    pickImageFile: function pickImageFile() {
      this.$refs.inputImageFile.click();
    },
    onVideoFilePicked: function onVideoFilePicked(e) {
      var file = void 0;
      for (var x = 0, xlen = e.target.files.length; x < xlen; x++) {
        file = e.target.files[x];
        if (file.type.indexOf('video') !== -1) {
          var reader = new FileReader();

          // reader.onload = e => {
          //   var img = new Image()
          //   img.src = e.target.result
          //   this.$refs.photo.src = img.src
          // }

          reader.readAsDataURL(file);
        }
      }
    },
    onImageFilePicked: function onImageFilePicked(e) {
      var file = void 0;
      for (var x = 0, xlen = e.target.files.length; x < xlen; x++) {
        file = e.target.files[x];
        if (file.type.indexOf('image') !== -1) {
          var reader = new FileReader();

          // reader.onload = e => {
          //   var img = new Image()
          //   img.src = e.target.result
          //   this.$refs.photo.src = img.src
          // }

          reader.readAsDataURL(file);
        }
      }
    },
    onSubmit: function onSubmit(e) {
      if (this.$refs.form.validate()) {
        var data = {
          author: this.author,
          cpd_points: this.cpdPoints,
          title: this.title,
          description: this.description,
          category: this.category,
          minimum_score: this.minimumScore,
          user_id: this.userId,
          video_segments: this.segmentData
        };

        var formData = new FormData();
        var videos = this.$refs.inputVideoFile.files;
        for (var v = 0; v < videos.length; v++) {
          formData.append('video', videos.item(v));
        };
        var images = this.$refs.inputImageFile.files;
        for (var i = 0; i < images.length; i++) {
          formData.append('image', images.item(i));
        };
        for (var prop in data) {
          if (Array.isArray(data[prop])) {
            data[prop].map(function (obj) {
              formData.append(prop + '[]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            });
          } else {
            formData.set('' + prop, '' + data[prop]);
          }
        }
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl + '/module', formData).then(function (e) {
          console.log(e);
        }).catch(function (e) {
          console.log(e);
        });
      }
    },
    addToArray: function addToArray() {
      var obj = {
        start_time: '',
        end_time: '',
        time: '',
        description: ''
      };
      this.segmentData.push(obj);
    },
    removeToArray: function removeToArray(index) {
      this.$delete(this.segmentData, index);
    },
    updateMultipleSegment: function updateMultipleSegment(obj, index) {
      this.segmentData[index] = obj;
    }
  },
  props: {
    apiUrl: {
      type: String
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      startTime: '',
      endTime: '',
      title: '',
      description: ''
    };
  },

  props: {
    index: {
      type: Number
    },
    totalIndex: {
      type: Number
    },
    addToArray: {
      type: Function
    },
    removeToArray: {
      type: Function
    },
    dataStartTime: {
      type: String
    },
    dataEndTime: {
      type: String
    },
    dataTitle: {
      type: String
    },
    dataDescription: {
      type: String
    },
    updateMultipleSegment: {
      type: Function
    }
  },
  methods: {
    removeDataToArray: function removeDataToArray(index) {
      this.removeToArray(index);
    },
    onChangeInput: function onChangeInput() {
      var obj = {
        start_time: this.startTime,
        end_time: this.endTime,
        title: this.title,
        description: this.description
      };
      this.updateMultipleSegment(obj, this.index);
    }
  },
  watch: {
    dataStartTime: function dataStartTime(val) {
      this.startTime = val;
    },
    dataEndTime: function dataEndTime(val) {
      this.endTime = val;
    },
    dataTitle: function dataTitle(val) {
      this.title = val;
    },
    dataDescription: function dataDescription(val) {
      this.description = val;
    }
  },
  mounted: function mounted() {
    this.startTime = this.dataStartTime;
    this.endTime = this.dataEndTime;
    this.title = this.dataTitle;
    this.description = this.dataDescription;
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_module_addQuestionForm__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_module_question__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var apiUrl = __WEBPACK_IMPORTED_MODULE_3__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddQuestionForm: __WEBPACK_IMPORTED_MODULE_1__components_admin_module_addQuestionForm__["a" /* default */],
    Question: __WEBPACK_IMPORTED_MODULE_2__components_admin_module_question__["a" /* default */]
  },
  created: function created() {
    this.moduleId = this.$route.params.id;
  },
  data: function data() {
    return {
      dialogAddQuestion: false,
      moduleId: null,
      author: null,
      category: null,
      cpdPoints: null,
      createdAt: null,
      description: null,
      image: null,
      minimumScore: null,
      title: null,
      userId: null,
      video: null
    };
  },

  methods: {
    getModuleById: function getModuleById(moduleId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + '/module/' + moduleId).then(function (res) {
        _this.author = res.data.author;
        _this.category = res.data.category;
        _this.cpdPoints = res.data.cpd_points;
        _this.createdAt = res.data.created_at;
        _this.description = res.data.description;
        _this.image = res.data.image;
        _this.minimumScore = res.data.minimum_score;
        _this.title = res.data.title;
        _this.userId = res.data.user_id;
        _this.video = res.data.video;
      });
    }
  },
  props: {
    apiUrl: String
  },
  watch: {
    moduleId: function moduleId(v) {
      this.getModuleById(v);
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var apiUrl = __WEBPACK_IMPORTED_MODULE_1__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      question: null
    };
  },

  methods: {
    submit: function submit() {
      this.onSubmit();
    },
    onSubmit: function onSubmit() {
      var formData = new FormData();
      formData.append('module_id', this.moduleId);
      formData.append('question', this.question);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/questionnaire', formData).then(function (res) {
        console.log(res);
      });
    }
  },
  props: {
    apiUrl: String,
    moduleId: String
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_module_question_choice__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_module_question_addChoiceForm__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var apiUrl = __WEBPACK_IMPORTED_MODULE_3__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Choice: __WEBPACK_IMPORTED_MODULE_1__components_admin_module_question_choice__["a" /* default */],
    AddChoiceForm: __WEBPACK_IMPORTED_MODULE_2__components_admin_module_question_addChoiceForm__["a" /* default */]
  },
  data: function data() {
    return {
      addChoiceForm: false,
      questions: [],
      selectedQuestionId: null
    };
  },

  methods: {
    onClick: function onClick(questionId) {
      console.log(questionId);
      this.selectedQuestionId = questionId;
      console.log(this.selectedQuestionId);
      this.addChoiceForm = true;
    },
    getQuestionsByModuleId: function getQuestionsByModuleId(moduleId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + '/questionnaire/module/' + moduleId).then(function (res) {
        console.log(res.data);
        _this.questions = res.data;
      });
    }
  },
  mounted: function mounted() {
    this.getQuestionsByModuleId(this.moduleId);
  },

  props: {
    apiUrl: String,
    moduleId: String
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'

/* harmony default export */ __webpack_exports__["a"] = ({
  // data () {
  //   return {
  //     token: JSON.parse(localStorage.getItem('token')),
  //     choices: []
  //   }
  // },
  // methods: {
  //   getChoicesByQuestionId (questionId) {
  //     axios.get(this.apiUrl + '/choices', {
  //       headers: {
  //         'Authorization': 'Bearer ' + this.token.access_token
  //       }
  //     }).then((res) => {
  //       console.log(res.data)
  //       this.choices = res.data
  //     })
  //   }
  // },
  // mounted () {
  //   this.getChoicesByQuestionId(this.questionId)
  // },
  props: {
    apiUrl: String,
    questionId: Number,
    choices: Array
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__configApi__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var apiUrl = __WEBPACK_IMPORTED_MODULE_1__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      label: null,
      value: null
    };
  },

  methods: {
    submit: function submit() {
      this.insertChoice(this.selectedQuestionId);
    },
    insertChoice: function insertChoice(questionId) {
      var formData = new FormData();
      formData.append('questionnaire_id', questionId);
      formData.append('label', this.label);
      formData.append('value', this.value);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/choices', formData).then(function (res) {
        console.log(res.data);
      });
    }
  },
  props: {
    apiUrl: String,
    selectedQuestionId: Number
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__configApi__);
//
//
//
//
//
//
//
//



var apiUrl = __WEBPACK_IMPORTED_MODULE_1__configApi___default.a.apiUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: 'checking for verification...'
    };
  },

  methods: {
    checkVerification: function checkVerification(token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + '/user/verify/' + token).then(function (res) {
        var token = res.data.data;
        _this.message = res.data.message;
        setTimeout(function () {
          if (token) {
            _this.$router.push('/password/reset/' + token);
            return;
          }
          _this.$router.push('/login');
        }, 2000);
      }).catch(function (err) {
        console.log(err);
        _this.message = err.response.data.message;
      });
    }
  },
  mounted: function mounted() {
    this.checkVerification(this.$route.params.token);
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configApi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__configApi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_token__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var API_URL = __WEBPACK_IMPORTED_MODULE_1__configApi___default.a.apiUrl;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      token: this.$route.params.token,
      email: '',
      password: '',
      password_confirmation: '',
      valid: true,
      emaiRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Required';
      }, function (v) {
        return v.length >= 6 || 'Password must be greater than 5 characters';
      }, function (v) {
        return _this.password_confirmation === _this.password || 'Password did not match';
      }]
    };
  },

  methods: {
    onClickSubmitReset: function onClickSubmitReset() {
      if (this.$refs.form.validate()) {
        this.sendResetPassword();
      }
    },
    sendResetPassword: function sendResetPassword() {
      var _this2 = this;

      var data = {
        token: this.token,
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation
      };
      this.valid = false;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(API_URL + '/password/reset', data).then(function (response) {
        var token = response.data.data;
        if (token) {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_token__["e" /* setAuthToken */])(token);
          _this2.setSessionUser();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setSessionUser: function setSessionUser() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(API_URL + '/user').then(function (res) {
        localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        sessionStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        _this3.$router.push('/dashboard');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imgHeight: 128,
      logo: __webpack_require__(11)
    };
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Merck__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_main_css__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mdi_css_materialdesignicons_min_css__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mdi_css_materialdesignicons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middleware__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_analytics__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import App from './App'









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a, {
  id: 'UA-179555242-3',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewOnLoad: true,
    page: true
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    primary: '#ee44aa',
    secondary: '#CC9AC6',
    accent: '#E82E8A',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});

Object(__WEBPACK_IMPORTED_MODULE_7__middleware__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]); // routes middleware

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__Merck__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Merck_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568575f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Merck_vue__ = __webpack_require__(296);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Merck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568575f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Merck_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports) {

module.exports = {"modules":[{"id":1,"image":"https://img.youtube.com/vi/b7JFqGMi9pk/hqdefault.jpg","title":"The Thyroid Gland","description":"Understanding the Basics","video":"www.youtube.com/watch?v=b7JFqGMi9pk","author":"Dr. Sjoberg","cpd_points":3},{"id":2,"image":"https://img.youtube.com/vi/mad4hZqXJgE/hqdefault.jpg","title":"Thyrotoxocosis and Hyperthyroidism","description":"Understanding the Basics","video":"www.youtube.com/watch?v=0T_P0m_er1w","author":"Dr. Sjoberg","cpd_points":3},{"id":3,"image":"https://img.youtube.com/vi/MVCRGso6tKw/hqdefault.jpg","title":"Hypothyroidism","description":"Recognition and Diagnosis Of Hypothyroidism","video":"www.youtube.com/watch?v=0cQCCkEDqEc","author":"Dr. Nemie","cpd_points":3},{"id":4,"image":"https://img.youtube.com/vi/_xmXCdIM-MI/hqdefault.jpg","title":"Management of Thyroid Disorders in Pregnancy","description":"","video":"www.youtube.com/watch?v=ndc8ACCL050","author":"Dr. Nemie","cpd_points":3},{"id":5,"image":"https://img.youtube.com/vi/XTRKwHLspls/hqdefault.jpg","title":"Iodine Nutrition: Why should we be concerned about it?","description":"Presentation Talk On-Line Course on Thyroid Disease","video":"www.youtube.com/watch?v=0T_P0m_er1w","author":"Dr. San Luis","cpd_points":3}],"questions":[{"id":"q1","moduleId":"","question":"Accoding to the module, in the mid part to be exact, an important part of the experiment, what are categorized as the biological class &lsquo;aves&rsquo;?","choices":[{"questionId":"q1","label":"Birds","value":"q1c1","points":1},{"questionId":"q1","label":"Aquatic Species","value":"q1c2","points":0},{"questionId":"q1","label":"Reptiles","value":"q1c3","points":0},{"questionId":"q1","label":"Mammals","value":"q1c4","points":0}]},{"id":"q2","moduleId":"","question":"Dr. Kiko Manisawa discussed the importance of observing the patient&rsquo;s eyes colors, what part of the eye gives it color?","choices":[{"questionId":"q2","label":"Iris","value":"q2c1","points":1},{"questionId":"q2","label":"Lens","value":"q2c2","points":0},{"questionId":"q2","label":"Pupil","value":"q2c3","points":"0"},{"questionId":"q2","label":"Retina","value":"q2c4","points":0}]},{"id":"q3","moduleId":"","question":"The revolutionary discovery of inert gases made a major impact to their study, who won a Nobel Prize for discovering this marvel?","choices":[{"questionId":"q3","label":"William Ramsey","value":"q3c1","points":1},{"questionId":"q3","label":"Andres Celsius","value":"q3c2","points":0},{"questionId":"q3","label":"John Palisa","value":"q3c3","points":0},{"questionId":"q3","label":"Jeanne Hopkins","value":"q3c4","points":0}]},{"id":"q4","moduleId":"","question":"This part of our chest plays a key element in determining such cases, what is the sternum more commonly known as?","choices":[{"questionId":"q4","label":"Breastbone","value":"q4c1","points":1},{"questionId":"q4","label":"Funnybone","value":"q4c2","points":0},{"questionId":"q4","label":"Skull Caps","value":"q4c3","points":0},{"questionId":"q4","label":"Greater Wing","value":"q4c4","points":0}]},{"id":"q5","moduleId":"","question":"If not cared for properly, this case could lead to Infantile Paralysis which is more commonly known as?","choices":[{"questionId":"q5","label":"Polio","value":"q5c1","points":1},{"questionId":"q5","label":"Diabetes","value":"q5c2","points":0},{"questionId":"q5","label":"Malaria","value":"q5c3","points":0},{"questionId":"q5","label":"Dehydration","value":"q5c4","points":0}]},{"id":"q1","moduleId":"","question":"Accoding to the module, in the mid part to be exact, an important part of the experiment, what are categorized as the biological class &lsquo;aves&rsquo;?","choices":[{"questionId":"q1","label":"Birds","value":"q1c1","points":1},{"questionId":"q1","label":"Aquatic Species","value":"q1c2","points":0},{"questionId":"q1","label":"Reptiles","value":"q1c3","points":0},{"questionId":"q1","label":"Mammals","value":"q1c4","points":0}]},{"id":"q2","moduleId":"","question":"Dr. Kiko Manisawa discussed the importance of observing the patient&rsquo;s eyes colors, what part of the eye gives it color?","choices":[{"questionId":"q2","label":"Iris","value":"q2c1","points":1},{"questionId":"q2","label":"Lens","value":"q2c2","points":0},{"questionId":"q2","label":"Pupil","value":"q2c3","points":"0"},{"questionId":"q2","label":"Retina","value":"q2c4","points":0}]},{"id":"q3","moduleId":"","question":"The revolutionary discovery of inert gases made a major impact to their study, who won a Nobel Prize for discovering this marvel?","choices":[{"questionId":"q3","label":"William Ramsey","value":"q3c1","points":1},{"questionId":"q3","label":"Andres Celsius","value":"q3c2","points":0},{"questionId":"q3","label":"John Palisa","value":"q3c3","points":0},{"questionId":"q3","label":"Jeanne Hopkins","value":"q3c4","points":0}]},{"id":"q4","moduleId":"","question":"This part of our chest plays a key element in determining such cases, what is the sternum more commonly known as?","choices":[{"questionId":"q4","label":"Breastbone","value":"q4c1","points":1},{"questionId":"q4","label":"Funnybone","value":"q4c2","points":0},{"questionId":"q4","label":"Skull Caps","value":"q4c3","points":0},{"questionId":"q4","label":"Greater Wing","value":"q4c4","points":0}]},{"id":"q5","moduleId":"","question":"If not cared for properly, this case could lead to Infantile Paralysis which is more commonly known as?","choices":[{"questionId":"q5","label":"Polio","value":"q5c1","points":1},{"questionId":"q5","label":"Diabetes","value":"q5c2","points":0},{"questionId":"q5","label":"Malaria","value":"q5c3","points":0},{"questionId":"q5","label":"Dehydration","value":"q5c4","points":0}]}]}

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('router-view',{attrs:{"apiUrl":_vm.apiUrl,"serverData":_vm.serverData}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_module__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_module_assessment__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_module_certificate__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_author__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_module__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_verify__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_passwords_reset__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_footer_privacy__ = __webpack_require__(407);


// import HelloWorld from '@/components/HelloWorld'

// import Access from '@/components/access'















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_login__["a" /* default */]
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_4__components_profile__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_5__components_dashboard__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/module/:id',
    name: 'Module',
    component: __WEBPACK_IMPORTED_MODULE_6__components_module__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/module/:id/assessment',
    name: 'MandatoryAssessMent',
    component: __WEBPACK_IMPORTED_MODULE_7__components_module_assessment__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate/:code',
    name: 'Certificate',
    component: __WEBPACK_IMPORTED_MODULE_8__components_module_certificate__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/author/:name',
    name: 'Author',
    component: __WEBPACK_IMPORTED_MODULE_9__components_author__["a" /* default */]
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_10__components_admin__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/admin/module/:id',
    name: 'Admin Module',
    component: __WEBPACK_IMPORTED_MODULE_11__components_admin_module__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/verify/email/:token',
    name: 'Verify Email',
    component: __WEBPACK_IMPORTED_MODULE_12__components_verify__["a" /* default */]
  }, {
    path: '/password/reset/:token',
    name: 'Password Reset',
    component: __WEBPACK_IMPORTED_MODULE_13__components_passwords_reset__["a" /* default */]
  }, {
    path: '/privacy/policy',
    name: 'policy',
    component: __WEBPACK_IMPORTED_MODULE_14__components_footer_privacy__["a" /* default */]
  }]
}));

/***/ }),
/* 298 */,
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8809bf4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8809bf4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_carousel_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47db3f29_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_carousel_vue__ = __webpack_require__(308);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47db3f29_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide1_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22df6c98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide1_vue__ = __webpack_require__(303);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22df6c98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/water_3.6d4eeec.png";

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center', backgroundSize: 'cover' }),attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-card',{staticClass:"pa-3"},[_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.logo,"height":"200"}}),_vm._v(" "),_c('p',[_vm._v("An online learning platform on thyroid disorders accessible for healthcare professionals in the Philippines.")])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide2_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb979452_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide2_vue__ = __webpack_require__(305);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb979452_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center', backgroundSize: 'cover' }),attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-card',{staticClass:"pa-5"},[_c('v-layout',{attrs:{"column":""}},[_c('h2',[_vm._v("LEARN AND EARN")]),_vm._v(" "),_c('h1',[_c('span',{staticClass:"primary--text"},[_vm._v("CPD")]),_vm._v(" POINTS")]),_vm._v(" "),_c('p',[_vm._v("Be among the 1st "),_c('b',{staticClass:"accent--text"},[_vm._v("1000 to complete the course!")]),_vm._v(" Learn from the world-class Filipino lecturers and earn units on the topics like "),_c('i',{staticClass:"purple--text"},[_vm._v("Iodine Nutrition, Management of Thyroid Disorders in Pregnancy, Hypothyroidism and more.")])])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"md6":"","text-xs-center":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.goto}},[_vm._v("Register for Full Access")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide3_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6a1bb8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide3_vue__ = __webpack_require__(307);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6a1bb8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center', backgroundSize: 'cover' }),attrs:{"grid-list-lg":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"md12":"","xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('h3',[_vm._v("WORLD CLASS LECTURERS")])]),_vm._v(" "),_vm._l((_vm.lecturers),function(lecturer,i){return _c('v-flex',{key:i,attrs:{"md4":"","sm4":"","hidden-xs-only":""}},[_c('v-card',{attrs:{"height":"400","to":lecturer.link}},[_c('v-card-media',{attrs:{"contain":"","src":lecturer.media,"height":"200"}}),_vm._v(" "),_c('v-card-title',[_c('strong',[_vm._v(_vm._s(lecturer.title))])]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(lecturer.text))])],1)],1)}),_vm._v(" "),_vm._l((_vm.lecturers),function(lecturer,i){return _c('v-flex',{key:i,attrs:{"xs12":"","hidden-sm-and-up":""}},[_c('v-card',{attrs:{"to":lecturer.link}},[_c('v-card-title',[_c('strong',[_vm._v(_vm._s(lecturer.title))])]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(lecturer.text))])],1)],1)})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{style:({ height: '92vh' }),attrs:{"light":"","hide-delimiters":"","interval":"100000"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i},[_c(item.src,{tag:"component"})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sampleModules_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed2453a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sampleModules_vue__ = __webpack_require__(310);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sampleModules_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed2453a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sampleModules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('h2',[_vm._v("Modules")]),_vm._v(" "),_c('p',{staticClass:"grey--text"},[_vm._v("Register to have full access of the modules")])]),_vm._v(" "),_vm._l((_vm.sampleModules),function(module,i){return _c('v-flex',{key:i,attrs:{"md4":""}},[_c('v-card',{attrs:{"height":"400"}},[_c('v-card-media',{attrs:{"src":module.image,"height":"200"}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"title mb-3"},[_vm._v(_vm._s(module.title))]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_vm._v(_vm._s(module.description))]),_vm._v(" "),_c('strong',[_c('span',[_vm._v("CPD Points")]),_vm._v(" "),_c('v-avatar',{attrs:{"color":"primary","size":"30"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(module.cpd_points))])])],1)])])],1)],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16469258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_vue__ = __webpack_require__(313);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16469258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/elearning.55cad02.png";

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"height":"200","src":_vm.bg}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286a55c3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__ = __webpack_require__(317);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286a55c3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 315 */,
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('section',[_c('p',{staticClass:"headline mb-5"},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('p',[_vm._v("Elite operates the Elite.ph website, which provides the SERVICE.")]),_vm._v(" "),_c('p',[_vm._v("This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.")]),_vm._v(" "),_c('p',[_vm._v("If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.")]),_vm._v(" "),_c('p',[_vm._v("The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Elite.ph, unless otherwise defined in this Privacy Policy.")]),_vm._v(" "),_c('p',[_vm._v("Information Collection and Use")]),_vm._v(" "),_c('p',[_vm._v("For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.")]),_vm._v(" "),_c('p',[_vm._v("Log Data")]),_vm._v(" "),_c('p',[_vm._v("We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol (“IP’) address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.")]),_vm._v(" "),_c('p',[_vm._v("Cookies\n\n      ")]),_c('p',[_vm._v("Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.")]),_vm._v(" "),_c('p',[_vm._v("Our website uses these “cookies” to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.")]),_vm._v(" "),_c('p',[_vm._v("Service Providers")]),_vm._v(" "),_c('p',[_vm._v("We may employ third-party companies and individuals due to the following reasons:")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("To facilitate our Service;")]),_vm._v(" "),_c('li',[_vm._v("To provide the Service on our behalf;")]),_vm._v(" "),_c('li',[_vm._v("To perform Service-related services; or")]),_vm._v(" "),_c('li',[_vm._v("To assist us in analyzing how our Service is used.")]),_vm._v(" "),_c('li',[_vm._v("We want to inform our Service users that these third parties have access to your Personal Information. ")]),_vm._v(" "),_c('li',[_vm._v("The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.")])])]),_vm._v(" "),_c('p',[_vm._v("Security")]),_vm._v(" "),_c('p',[_vm._v("We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.")]),_vm._v(" "),_c('p',[_vm._v("Links to Other Sites")]),_vm._v(" "),_c('p',[_vm._v("Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.")]),_vm._v(" "),_c('p',[_vm._v("Children’s Privacy")]),_vm._v(" "),_c('p',[_vm._v("Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.")]),_vm._v(" "),_c('p',[_vm._v("Changes to This Privacy Policy")]),_vm._v(" "),_c('p',[_vm._v("We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.")]),_vm._v(" "),_c('p',[_vm._v("Contact Us")]),_vm._v(" "),_c('p',[_vm._v("If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"I agree to the site's Privacy Policy","rules":_vm.agreePolicyRules},model:{value:(_vm.agreePolicy),callback:function ($$v) {_vm.agreePolicy=$$v},expression:"agreePolicy"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":"","id":"regFormContainer"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"md8":""}},[_c('v-card',[_c('v-form',{ref:"form"},[_c('v-card-title',[_c('h2',[_vm._v("REGISTER NOW!")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_vm._v("\n                    If you're interested to know more about our programs,\n                    please feel free to reach out!\n                  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('strong',{staticClass:"mb-3"},[_vm._v("Basic Details")]),_vm._v(" "),_c('v-subheader',{staticClass:"primary--text"},[_c('strong',[_c('em',[_vm._v("* Please select first your country of origin. Kindly\n                        provide your complete name that appears on your\n                        professional ID..")])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Country","items":_vm.countries,"item-value":"value","item-text":"label","rules":[function (v) { return !!v || 'country is required'; }],"required":""},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1),_vm._v(" "),(_vm.country === 'Malaysia')?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Full Name","rules":_vm.wholeNameRules,"required":""},model:{value:(_vm.wholeName),callback:function ($$v) {_vm.wholeName=$$v},expression:"wholeName"}})],1):_vm._e(),_vm._v(" "),(_vm.country !== 'Malaysia')?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Last Name","rules":_vm.lastNameRules,"required":""},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1):_vm._e(),_vm._v(" "),(_vm.country !== 'Malaysia')?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"First Name","rules":_vm.firstNameRules,"required":""},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1):_vm._e(),_vm._v(" "),(_vm.country !== 'Malaysia')?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Specialization","items":_vm.specialtyList,"item-value":"value","item-text":"label","rules":[function (v) { return !!v || 'Specialization is required'; }],"required":""},model:{value:(_vm.specialization),callback:function ($$v) {_vm.specialization=$$v},expression:"specialization"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Email Address","rules":_vm.emailRules,"required":"","prepend-icon":"email"},model:{value:(_vm.emailAddress),callback:function ($$v) {_vm.emailAddress=$$v},expression:"emailAddress"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('strong',{staticClass:"mb-3"},[_vm._v("PRC Registration")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"PRC Number","rules":_vm.prcNumberRules,"required":""},model:{value:(_vm.prcNumber),callback:function ($$v) {_vm.prcNumber=$$v},expression:"prcNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Date of PRC Registration","type":"date","rules":_vm.prcRegistrationDateRules,"required":""},model:{value:(_vm.prcRegistrationDate),callback:function ($$v) {_vm.prcRegistrationDate=$$v},expression:"prcRegistrationDate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Valid Until","type":"date","rules":_vm.prcValidityRules,"required":""},model:{value:(_vm.prcValidity),callback:function ($$v) {_vm.prcValidity=$$v},expression:"prcValidity"}}),_vm._v("``\n                ")],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-checkbox',{attrs:{"rules":_vm.agreePolicyRules},model:{value:(_vm.agreePolicy),callback:function ($$v) {_vm.agreePolicy=$$v},expression:"agreePolicy"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                      I agree to the site's\n                      "),_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.showPrivacyPolicyDialog($event)}}},[_vm._v("Privacy Statement and Terms of Use.")])])])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('label',{staticStyle:{"color":"rgba(0, 0, 0, 0.54)"}},[_vm._v("By clicking below, I agree to be notified through email\n                    for any updates on this program.")])])],1),_vm._v(" "),(_vm.notifyToMobile)?_c('v-layout',[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"label":"Mobile Number","mask":"#### ### - ####","prepend-icon":"phone"},model:{value:(_vm.mobileNumberInputField),callback:function ($$v) {_vm.mobileNumberInputField=$$v},expression:"mobileNumberInputField"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',[_c('v-container',[_c('v-flex',[_c('v-checkbox',{attrs:{"label":"Email","hide-details":""},model:{value:(_vm.notifyToEmail),callback:function ($$v) {_vm.notifyToEmail=$$v},expression:"notifyToEmail"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs6":"","text-xs-center":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.submitbutton},on:{"click":_vm.submit}},[_vm._v("Submit")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800"},model:{value:(_vm.privacyPolicyDialog),callback:function ($$v) {_vm.privacyPolicyDialog=$$v},expression:"privacyPolicyDialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("Terms of Use and Privacy Statement")])]),_vm._v(" "),_c('v-card-text',[_c('section',[_c('ol',[_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("MERCK, INC. General Terms and Conditions.")])]),_vm._v(" "),_c('p',[_vm._v("\n              Access to and use of this website are both subject to the\n              following conditions. Should you disagree with these conditions,\n              please do not use this website.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              This website is operated by IPADAMA 360 INC., a service provider\n              of Merck, Inc. (hereinafter also “Merck”, “we”, “us” or “our”).\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              This website is for general informational and educational\n              purposes only and, although it may be available in different\n              languages, it is not country specific. By using this website you\n              declare that you use it and its content at your own risk.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Under no circumstances may this website or its contents may be\n              used or understood as a substitute for healthcare professional\n              advice and is not to be used for diagnosis of any health problem\n              or disease. Patients should always consult a doctor or another\n              healthcare professional for medical advice or information about\n              diagnosis and treatment. If your situation is serious, always\n              call the emergency service.\n            ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("1. Exclusion of liability")])]),_vm._v(" "),_c('p',[_vm._v("\n              We have compiled the content of this website carefully and in\n              accordance with the current state of knowledge. However, we give\n              no warranty, neither expressly nor tacitly, for the completeness\n              or correctness of the details provided on this website. Please\n              be aware, in particular, that the details we provide may no\n              longer be up-to-date.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Access to and use of this website and of any associated sites or\n              sites connected via links take place at the user’s own risk. We\n              accept no liability for loss, damage or compensation claims due\n              to missing or incorrect details. The Website and any services\n              available through it are available solely for the User's\n              personal and not for commercial use.\n            ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("2. Legal notes")])]),_vm._v(" "),_c('p',[_vm._v("\n              All rights to the website or arising from the same shall remain\n              with Merck, Inc. or its affiliates.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              We may modify this website and/or discontinue its operation at\n              any time without prior announcement, either wholly or in parts,\n              at ourits own discretion and without accepting liability.\n              Neither is Merck, under an obligation to update the content of\n              this website.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Unless otherwise indicated, all details, documents and\n              presentations published on our website are under the sole\n              ownership of Merck, Inc., its affiliates or third parties that\n              have authorized its use. Unless written consent has been\n              obtained from us, no permission is given to import published and\n              copyrighted content from our website to other programs or\n              website or to use such content in any other way.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Access to this website is public and does not require\n              registration. Please, be aware that users may be subject to\n              provisions under local legislation. International users must\n              observe the special provisions under local legislation. Users in\n              the United States are subject to the conditions of use for the\n              websites of our U.S. companies.\n            ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("3. Personal data")])]),_vm._v(" "),_c('p',[_vm._v("\n              We are concerned to ensure the protection of your personal data.\n              You will find information on the use of personal data in the\n              Privacy Statement.\n            ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("4. Content")])]),_vm._v(" "),_c('p',[_vm._v("\n              This website may contain general information regarding medical\n              conditions. Such information is provided for informational\n              purposes only, under no circumstances may it be used or\n              understood as a substitute for healthcare professional advice\n              and is not to be used for diagnosis of any health problem or\n              disease. Patients should always consult a doctor or another\n              healthcare professional for medical advice or information about\n              diagnosis and treatment.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              The website may also include links to third-party websites. Such\n              links are provided merely as a convenience. The content of\n              third-party web sites is beyond our control and we make no\n              warranties or representations regarding the accuracy or validity\n              of such information. Neither do the links represent any kind of\n              support or endorsement of the linked website's contents. Access\n              to and use of sites connected via links take place at the user’s\n              own risk.\n            ")]),_vm._v(" "),_c('p',[_vm._v("As of: April 2024")])])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.privacyPolicyDialog = false}}},[_vm._v("Close")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.notificationResponse),callback:function ($$v) {_vm.notificationResponse=$$v},expression:"notificationResponse"}},[_c('v-card',[_c('v-card-text',[_c('h2',{staticClass:"text-xs-center"},[_vm._v("Congratulations!")]),_vm._v(" "),_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.text))])])],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":"","color":"info"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","color":"pink"},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */,
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"noprint"},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',[_c('img',{attrs:{"height":"75","src":_vm.logo}})]),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down"},[_c('v-layout',[_c('v-flex',{attrs:{"text-xs-center":""}},[_vm._v("PH-EUT-00098 APR 2024")]),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-center":""}},[_c('router-link',{attrs:{"to":"/privacy/policy"}},[_vm._v("\n            Privacy Statement\n          ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-center":""}},[_c('a',{on:{"click":function($event){$event.stopPropagation();_vm.contactUsDialog = true}}},[_vm._v("Contact Us")])]),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-center":""}},[_vm._v("Ipadama © 2018")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":""}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-facebook-box")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-twitter-box")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-linkedin-box")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800"},model:{value:(_vm.contactUsDialog),callback:function ($$v) {_vm.contactUsDialog=$$v},expression:"contactUsDialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("CONTACT US")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        You may contact us at "),_c('a',{attrs:{"href":"mailto:askeliteonline@gmail.com"}},[_vm._v("askeliteonline@gmail.com")]),_vm._v(".\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"color":"white","dense":"","flat":""}},[_c('v-spacer'),_vm._v(" "),(!_vm.token)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":_vm.loginClick}},[_vm._v("\n      Login\n    ")]):_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":_vm.goToDashboard}},[_vm._v("\n      dashboard\n    ")])],1),_vm._v(" "),_c('carousel'),_vm._v(" "),_c('sample-modules',{staticClass:"mt-5"}),_vm._v(" "),_c('parallax',{staticClass:"mt-5"}),_vm._v(" "),_c('div',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center' })},[_c('registration')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('main-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c2b47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(324);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c2b47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDI2IDI2MSAxNDMuMTEgMTAwIj4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xLCAuY2xzLTIgew0KICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7DQogICAgICB9DQoNCiAgICAgIC5jbHMtMSB7DQogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsNCiAgICAgIH0NCg0KICAgICAgLmNscy0yIHsNCiAgICAgICAgZmlsbDogI2U4MmU4YTsNCiAgICAgIH0NCiAgICA8L3N0eWxlPg0KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iMC4xMzkiIHkxPSIwLjg0IiB4Mj0iMC44NjEiIHkyPSIwLjE2IiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+DQogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNlODJlOGEiLz4NCiAgICAgIDxzdG9wIG9mZnNldD0iMC42MzkiIHN0b3AtY29sb3I9IiNlZTcyYWUiLz4NCiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2Y1YjdkMyIvPg0KICAgIDwvbGluZWFyR3JhZGllbnQ+DQogIDwvZGVmcz4NCiAgPGcgaWQ9Ikdyb3VwXzI3MyIgZGF0YS1uYW1lPSJHcm91cCAyNzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDM1KSI+DQogICAgPHBhdGggaWQ9IlBhdGhfNjU1IiBkYXRhLW5hbWU9IlBhdGggNjU1IiBjbGFzcz0iY2xzLTEiIGQ9Ik0xMTM0LjU5NCwzMy4xczE0LjQ0OC0xNS44MjQsMTAuODYxLTI0LjAzMWMtMy41ODctOC4yNTYtMjguOC0yLjYtNDguOSwxMi4wNC0xMy40MTYsOS43My0xOC43NzMsMTcuNTkzLTIwLjc4NywyMi41NTctMS41NzMsMy44ODItMi4yNjEsNy4yNzMsMS45NjYsOS40MzUsMi41MDYsMS4yNzgsNy4wNzcsMi44NSwxNS41MjksNS4yNTgtMTMuMjE5LDEuNTczLTI0Ljk2NS4yNDYtMjUuOSwxMi40ODItLjk4MywxNC4wMDYsMTcuOTM3LDI3LjY2NywzMC4xNzQsMjMuODgzYTEyLjE3NSwxMi4xNzUsMCwwLDAsOC41NTEtMTAuMTIzYy42MzktMy45MzEtLjE0Ny05LjYzMi01LjE2LTE3LDE5LjA2OCwxNi40MTQsMy4xOTQsNDAuMjQ4LTIxLjA4MiwyOS44My0xMi44MjYtNS40NTUtMTguMDM2LTEzLjUxNC0yMC4xNDktMTkuODU0LTIuNzUyLTguNS0uMS0xNy42NDIsOC4wNTktMjEuOTY3LTEwLjIyMi0xNC4wNTUsMTUuNjI4LTM0LjU0NywyNS42LTQwLjc4OSwxOS42NTctMTIuMzM1LDQ1LjctMjAuODM3LDU0LjE1Ni05LjU4M0MxMTU2LjY1OSwxNy40NzMsMTEzNC41OTQsMzMuMSwxMTM0LjU5NCwzMy4xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM5Ny42MjcgMjYxLjAyMykiLz4NCiAgICA8cGF0aCBpZD0iUGF0aF82NTYiIGRhdGEtbmFtZT0iUGF0aCA2NTYiIGNsYXNzPSJjbHMtMiIgZD0iTTIwLjYxLDI2OS40MDdBMjguMTUyLDI4LjE1MiwwLDAsMSw2LjY1NCwyNDguMTI5Yy0xLjAzMi04Ljk5MywyLjU1NS0xNC44NDEsOC43LTE3LDE0Ljc0My01LjI1OCwzMi42MzEsOS4zODYsMzQuNjk1LDI0LjAzMS41NDEsMy44MzMtLjI0Niw3LjIyNC0yLjcsOS40ODUtMy4xOTQsMi45NDktNS44LDMuNTg3LTMuNzg0LDkuMjM5LDEuODY3LDUuMjU4LTguNywyMi43LTMzLjYxNCwyNy44NjQsMCwwLTYuOTI5LDEuMTMtNy4wNzctMy41MzgtLjE0Ny00LjYxOSw2LjE5Mi0xNC4wNTUsMTMuOTA3LTE4LjU3NiwwLDAtMTEuNyw1LjgtMTUuNDgsMTMuNzYtMy4zOTEsNy4xNzUuMiwxMS42LDguMTA5LDExLjEwNiw4LjAxLS41NDEsMTguMzc5LTUuMTExLDE4LjM3OS01LjExMXMxOC44MjItOS4xOSwyMS4yMy0yMS4zNzdhMTEuMTQ3LDExLjE0NywwLDAsMC0uNDQyLTYuMDk0cy0uMzkzLTEuNTczLjM0NC0xLjk2NmMuNzg2LS4zNDQsNy40MjEtNS4yMDksNi44MzEtMTMuNTE0LS41NDEtOC4zMDUtNC4yMjYtMTguNTc2LTE3LjU5My0yNS43LTEzLjk1Ny03LjQyMS0zNy41LTUuNy0zNC43OTMsMTUuNDhDNC43ODYsMjU3LjMxOCwxNC4wMjUsMjY4LjA4MSwyMC42MSwyNjkuNDA3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjA4Ljk4IDQ1LjQwNSkiLz4NCiAgPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 
    backgroundImage: 'url(' + _vm.bg + ')', 
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100vh'
  })},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","fill-height":"","justify-center":""}},[_c('v-flex',{attrs:{"sm8":"","md6":""}},[_c('v-card',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"sm10":"","md10":""}},[_c('v-card-title',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md4":""}},[_c('img',{attrs:{"src":_vm.logo}})]),_vm._v(" "),_c('v-flex',{staticClass:"display-1",attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Log In")])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.validForm),callback:function ($$v) {_vm.validForm=$$v},expression:"validForm"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"subheading",attrs:{"xs12":""}},[_c('span',{staticClass:"secondary--text"},[_vm._v("Enter your email and password")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Username / Email Address","rules":_vm.usernameRules},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Password","rules":_vm.passwordRules,"append-icon":_vm.pw ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.pw = !_vm.pw); },"type":_vm.pw ? 'password' : 'text'},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"margin":"0"},attrs:{"flat":"","dark":"","color":"primary"},on:{"click":_vm.openResetPasswordDialog}},[_vm._v("Forgot password?")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":""}},[(_vm.enableVerificationButton)?_c('v-flex',{attrs:{"xs12":"","text-sm-right":""}},[_c('v-btn',{attrs:{"color":"blue","depressed":""},on:{"click":_vm.onClickVerification}},[_vm._v("\n                        Resend Verification\n                      ")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-sm-right":""}},[_c('v-btn',{attrs:{"slot":"activator","type":"submit","color":"primary","depressed":"","disabled":!_vm.validForm},slot:"activator"},[_vm._v("\n                        Log In\n                      ")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogresetForm),callback:function ($$v) {_vm.dialogresetForm=$$v},expression:"dialogresetForm"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Reset Password")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"resetPasswordForm",attrs:{"lazy-validation":""},model:{value:(_vm.resetPasswordForm),callback:function ($$v) {_vm.resetPasswordForm=$$v},expression:"resetPasswordForm"}},[_c('v-text-field',{attrs:{"label":"E-mail Address","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"text-sm-right":""}},[_c('v-btn',{attrs:{"color":"primary","depressed":"","disabled":!_vm.resetPasswordForm},on:{"click":_vm.onClickPasswordReset}},[_vm._v("\n                    Send\n                  ")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogResendVerification),callback:function ($$v) {_vm.dialogResendVerification=$$v},expression:"dialogResendVerification"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Resend Verification")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"resendVerificationForm",attrs:{"lazy-validation":""},model:{value:(_vm.resendVerificationForm),callback:function ($$v) {_vm.resendVerificationForm=$$v},expression:"resendVerificationForm"}},[_c('v-text-field',{attrs:{"label":"E-mail Address","rules":_vm.emailRules,"required":""},model:{value:(_vm.email_verify),callback:function ($$v) {_vm.email_verify=$$v},expression:"email_verify"}}),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"text-sm-right":""}},[_c('v-btn',{attrs:{"color":"primary","depressed":"","disabled":!_vm.resendVerificationForm},on:{"click":_vm.onClickResendVerification}},[_vm._v("\n                    "+_vm._s(_vm.resendVerificationForm ? 'send' : 'process...')+"\n                  ")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac2eb37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(332);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac2eb37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileHeader_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376a8dca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profileHeader_vue__ = __webpack_require__(327);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376a8dca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profileHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('img',{attrs:{"height":_vm.imgHeight,"src":_vm.logo}})])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"text-md-right":""}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681be476_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(331);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681be476_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-card',[_c('v-container',{staticClass:"pa-5"},[_c('v-layout',{staticClass:"mb-5",attrs:{"align-center":""}},[_c('v-flex',[_c('v-avatar',{staticClass:"mr-3",style:({ cursor: 'pointer' }),attrs:{"size":"150"},on:{"click":_vm.pickFile}},[_c('img',{ref:"photo",attrs:{"src":_vm.user.image_url,"alt":"avatar"}})]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.pickFile}},[_c('v-icon',{attrs:{"color":"accent"}},[_vm._v("photo_camera")]),_vm._v(" "),_c('strong',{staticClass:"accent--text"},[_vm._v("Change Photo")])],1),_vm._v(" "),_c('input',{ref:"inputFile",style:({ display: 'none' }),attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('strong',{staticClass:"mb-3"},[_vm._v("Basic Details")]),_vm._v(" "),_c('v-subheader',[_c('em',[_vm._v("* Use name appeared in PRC ID")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Last Name","rules":_vm.lastNameRules,"required":""},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"First Name","rules":_vm.firstNameRules,"required":""},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Other Contact details"},model:{value:(_vm.otherContactDetails),callback:function ($$v) {_vm.otherContactDetails=$$v},expression:"otherContactDetails"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Specialization","items":_vm.specialtyList,"item-value":"value","item-text":"label","rules":[function (v) { return !!v || 'Specialization is required'; }],"required":""},model:{value:(_vm.specialization),callback:function ($$v) {_vm.specialization=$$v},expression:"specialization"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('strong',{staticClass:"mb-3"},[_vm._v("PRC Registration")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"PRC Number","rules":_vm.prcNumberRules,"required":""},model:{value:(_vm.prcNumber),callback:function ($$v) {_vm.prcNumber=$$v},expression:"prcNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Date of Registration","type":"date","rules":_vm.prcRegistrationDateRules,"required":""},model:{value:(_vm.prcRegistrationDate),callback:function ($$v) {_vm.prcRegistrationDate=$$v},expression:"prcRegistrationDate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Valid Until","type":"date","rules":_vm.prcValidityRules,"required":""},model:{value:(_vm.prcValidity),callback:function ($$v) {_vm.prcValidity=$$v},expression:"prcValidity"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{staticClass:"pa-5"},[_c('v-layout',{staticClass:"mb-5"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-right":""}},[_c('v-btn',{staticClass:"secondary secondary--text",attrs:{"outline":"","to":"/dashboard"}},[_vm._v("\n            Back\n          ")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.formValid},on:{"click":_vm.submit}},[_vm._v("\n            Submit\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":"","color":"info"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","color":"pink"},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 
    backgroundImage: 'url(' + _vm.bg + ')',
    backgroundPosition: 'center'
  })},[_c('profile-header'),_vm._v(" "),_c('v-container',{attrs:{"fill-height":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('registration',{attrs:{"apiUrl":_vm.apiUrl}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eea8b16c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eea8b16c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 334 */,
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 79,
	"./af.js": 79,
	"./ar": 80,
	"./ar-dz": 81,
	"./ar-dz.js": 81,
	"./ar-kw": 82,
	"./ar-kw.js": 82,
	"./ar-ly": 83,
	"./ar-ly.js": 83,
	"./ar-ma": 84,
	"./ar-ma.js": 84,
	"./ar-sa": 85,
	"./ar-sa.js": 85,
	"./ar-tn": 86,
	"./ar-tn.js": 86,
	"./ar.js": 80,
	"./az": 87,
	"./az.js": 87,
	"./be": 88,
	"./be.js": 88,
	"./bg": 89,
	"./bg.js": 89,
	"./bm": 90,
	"./bm.js": 90,
	"./bn": 91,
	"./bn.js": 91,
	"./bo": 92,
	"./bo.js": 92,
	"./br": 93,
	"./br.js": 93,
	"./bs": 94,
	"./bs.js": 94,
	"./ca": 95,
	"./ca.js": 95,
	"./cs": 96,
	"./cs.js": 96,
	"./cv": 97,
	"./cv.js": 97,
	"./cy": 98,
	"./cy.js": 98,
	"./da": 99,
	"./da.js": 99,
	"./de": 100,
	"./de-at": 101,
	"./de-at.js": 101,
	"./de-ch": 102,
	"./de-ch.js": 102,
	"./de.js": 100,
	"./dv": 103,
	"./dv.js": 103,
	"./el": 104,
	"./el.js": 104,
	"./en-au": 105,
	"./en-au.js": 105,
	"./en-ca": 106,
	"./en-ca.js": 106,
	"./en-gb": 107,
	"./en-gb.js": 107,
	"./en-ie": 108,
	"./en-ie.js": 108,
	"./en-il": 109,
	"./en-il.js": 109,
	"./en-in": 110,
	"./en-in.js": 110,
	"./en-nz": 111,
	"./en-nz.js": 111,
	"./en-sg": 112,
	"./en-sg.js": 112,
	"./eo": 113,
	"./eo.js": 113,
	"./es": 114,
	"./es-do": 115,
	"./es-do.js": 115,
	"./es-us": 116,
	"./es-us.js": 116,
	"./es.js": 114,
	"./et": 117,
	"./et.js": 117,
	"./eu": 118,
	"./eu.js": 118,
	"./fa": 119,
	"./fa.js": 119,
	"./fi": 120,
	"./fi.js": 120,
	"./fil": 121,
	"./fil.js": 121,
	"./fo": 122,
	"./fo.js": 122,
	"./fr": 123,
	"./fr-ca": 124,
	"./fr-ca.js": 124,
	"./fr-ch": 125,
	"./fr-ch.js": 125,
	"./fr.js": 123,
	"./fy": 126,
	"./fy.js": 126,
	"./ga": 127,
	"./ga.js": 127,
	"./gd": 128,
	"./gd.js": 128,
	"./gl": 129,
	"./gl.js": 129,
	"./gom-deva": 130,
	"./gom-deva.js": 130,
	"./gom-latn": 131,
	"./gom-latn.js": 131,
	"./gu": 132,
	"./gu.js": 132,
	"./he": 133,
	"./he.js": 133,
	"./hi": 134,
	"./hi.js": 134,
	"./hr": 135,
	"./hr.js": 135,
	"./hu": 136,
	"./hu.js": 136,
	"./hy-am": 137,
	"./hy-am.js": 137,
	"./id": 138,
	"./id.js": 138,
	"./is": 139,
	"./is.js": 139,
	"./it": 140,
	"./it-ch": 141,
	"./it-ch.js": 141,
	"./it.js": 140,
	"./ja": 142,
	"./ja.js": 142,
	"./jv": 143,
	"./jv.js": 143,
	"./ka": 144,
	"./ka.js": 144,
	"./kk": 145,
	"./kk.js": 145,
	"./km": 146,
	"./km.js": 146,
	"./kn": 147,
	"./kn.js": 147,
	"./ko": 148,
	"./ko.js": 148,
	"./ku": 149,
	"./ku.js": 149,
	"./ky": 150,
	"./ky.js": 150,
	"./lb": 151,
	"./lb.js": 151,
	"./lo": 152,
	"./lo.js": 152,
	"./lt": 153,
	"./lt.js": 153,
	"./lv": 154,
	"./lv.js": 154,
	"./me": 155,
	"./me.js": 155,
	"./mi": 156,
	"./mi.js": 156,
	"./mk": 157,
	"./mk.js": 157,
	"./ml": 158,
	"./ml.js": 158,
	"./mn": 159,
	"./mn.js": 159,
	"./mr": 160,
	"./mr.js": 160,
	"./ms": 161,
	"./ms-my": 162,
	"./ms-my.js": 162,
	"./ms.js": 161,
	"./mt": 163,
	"./mt.js": 163,
	"./my": 164,
	"./my.js": 164,
	"./nb": 165,
	"./nb.js": 165,
	"./ne": 166,
	"./ne.js": 166,
	"./nl": 167,
	"./nl-be": 168,
	"./nl-be.js": 168,
	"./nl.js": 167,
	"./nn": 169,
	"./nn.js": 169,
	"./oc-lnc": 170,
	"./oc-lnc.js": 170,
	"./pa-in": 171,
	"./pa-in.js": 171,
	"./pl": 172,
	"./pl.js": 172,
	"./pt": 173,
	"./pt-br": 174,
	"./pt-br.js": 174,
	"./pt.js": 173,
	"./ro": 175,
	"./ro.js": 175,
	"./ru": 176,
	"./ru.js": 176,
	"./sd": 177,
	"./sd.js": 177,
	"./se": 178,
	"./se.js": 178,
	"./si": 179,
	"./si.js": 179,
	"./sk": 180,
	"./sk.js": 180,
	"./sl": 181,
	"./sl.js": 181,
	"./sq": 182,
	"./sq.js": 182,
	"./sr": 183,
	"./sr-cyrl": 184,
	"./sr-cyrl.js": 184,
	"./sr.js": 183,
	"./ss": 185,
	"./ss.js": 185,
	"./sv": 186,
	"./sv.js": 186,
	"./sw": 187,
	"./sw.js": 187,
	"./ta": 188,
	"./ta.js": 188,
	"./te": 189,
	"./te.js": 189,
	"./tet": 190,
	"./tet.js": 190,
	"./tg": 191,
	"./tg.js": 191,
	"./th": 192,
	"./th.js": 192,
	"./tl-ph": 193,
	"./tl-ph.js": 193,
	"./tlh": 194,
	"./tlh.js": 194,
	"./tr": 195,
	"./tr.js": 195,
	"./tzl": 196,
	"./tzl.js": 196,
	"./tzm": 197,
	"./tzm-latn": 198,
	"./tzm-latn.js": 198,
	"./tzm.js": 197,
	"./ug-cn": 199,
	"./ug-cn.js": 199,
	"./uk": 200,
	"./uk.js": 200,
	"./ur": 201,
	"./ur.js": 201,
	"./uz": 202,
	"./uz-latn": 203,
	"./uz-latn.js": 203,
	"./uz.js": 202,
	"./vi": 204,
	"./vi.js": 204,
	"./x-pseudo": 205,
	"./x-pseudo.js": 205,
	"./yo": 206,
	"./yo.js": 206,
	"./zh-cn": 207,
	"./zh-cn.js": 207,
	"./zh-hk": 208,
	"./zh-hk.js": 208,
	"./zh-mo": 209,
	"./zh-mo.js": 209,
	"./zh-tw": 210,
	"./zh-tw.js": 210
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noprint"},[_c('v-container',{staticClass:"hidden-sm-and-down"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('img',{attrs:{"height":_vm.imgHeight,"src":_vm.logo}})])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.token)?_c('v-flex',{attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"flat":"","to":"/profile"}},[_c('strong',[_vm._v("Hi! Doctor "+_vm._s(_vm.user.lastname)+"!")])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.logout}},[_c('strong',[_vm._v("Log out")])])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"hidden-md-and-up"},[_c('v-toolbar-title',[_c('img',{attrs:{"src":_vm.logo,"height":"32"}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.token)?_c('v-toolbar-items',[_c('v-btn',{attrs:{"flat":"","to":"/profile"}},[_c('strong',[_vm._v("Hi! Doctor "+_vm._s(_vm.user.lastname)+"!")])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.logout}},[_c('strong',[_vm._v("Log out")])])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_latestModules_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fdc0d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_latestModules_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_latestModules_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fdc0d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_latestModules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center' })},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"justify-space-between":"","wrap":""}}),_vm._v(" "),_c('v-layout',{staticClass:"mb-3"},[_c('v-flex',[_c('strong',[_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.completedModules))]),_vm._v("/"+_vm._s(_vm.totalModules)+" Videos watched")]),_vm._v("\n        as of "+_vm._s(_vm.dateToday)+"\n      ")])],1),_vm._v(" "),_c('v-data-iterator',{attrs:{"content-tag":"v-layout","row":"","wrap":"","items":_vm.modules,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg4":""}},[_c('v-card',{attrs:{"hover":""},nativeOn:{"click":function($event){return _vm.handleClick(props.item)}}},[_c('v-card-media',{attrs:{"src":props.item.image,"height":"200"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-end":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"text-md-right":""}},[(_vm.isAlreadyWatched(props.item))?_c('div',[_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_c('strong',[_vm._v("Completed")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("star")])],1)],1):_vm._e()])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',[_vm._v(_vm._s(props.item.title))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('em',[_vm._v("by "+_vm._s(props.item.author))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"codes_style"},[_vm._v(_vm._s(props.item.codes))])])],1)],1)],1),_vm._v(" "),_c('v-card-text')],1)],1)}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allModules_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094abe48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allModules_vue__ = __webpack_require__(343);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allModules_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094abe48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allModules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center' })},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.allModules),function(module,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm6":"","md4":"","lg4":""}},[_c('v-card',{attrs:{"hover":""},nativeOn:{"click":function($event){return _vm.handleClick(module)}}},[_c('v-card-media',{attrs:{"src":module.image ? module.image : '',"height":"200"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-end":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"text-md-right":""}},[(_vm.isAlreadyWatched(module))?_c('div',[_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_c('strong',[_vm._v("Completed")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("star")])],1)],1):_vm._e()])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',[_vm._v(_vm._s(module.title))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('em',[_vm._v("by "+_vm._s(module.author))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"codes_style"},[_vm._v(_vm._s(module.codes))])])],1)],1)],1),_vm._v(" "),_c('v-card-text')],1)],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activities_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4051b154_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activities_vue__ = __webpack_require__(345);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4051b154_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center' })},[_c('v-container',[_c('v-layout',{staticClass:"mb-3",attrs:{"align-center":"","justify-space-between":"","wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"md4":"","order-sm2":""}},[_c('v-text-field',{attrs:{"solo":"","label":"Search Activites","prepend-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":"","order-sm1":""}},[_c('strong',[_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.activitiesCount))]),_vm._v(" "),_c('span',[_vm._v("Latest Activities")])]),_vm._v(" "),_c('span',[_vm._v("as of "+_vm._s(_vm.dateToday))])])],1),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"two-line":"","subheader":""}},_vm._l((_vm.filteredActivities),function(activity,i){return _c('v-list-tile',{key:i,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":activity.module.image}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(activity.module.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[(activity.earned)?_c('span',[_vm._v("\n                Completed\n                "+_vm._s()+"\n              ")]):_c('span',[_c('a',{on:{"click":function($event){return _vm.handleClick(activity.module)}}},[_vm._v("Continue")])]),_vm._v(" "),_c('span',[_vm._v(" - ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.convertDate(activity.created_at)))])])],1)],1)}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52aa93ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(347);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52aa93ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center' })},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.authors),function(author,i){return _c('v-flex',{key:i,attrs:{"sm4":""}},[_c('v-card',{attrs:{"to":author.link}},[_c('v-card-media',{attrs:{"contain":"","src":author.media,"height":"20em"}}),_vm._v(" "),_c('v-card-title',{staticClass:"text-md-center purple--text"},[_c('div',{staticStyle:{"margin":"0 auto"}},[_vm._v(_vm._s(author.title))])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-md-center"},[_vm._v("\n            "+_vm._s(author.text)+"\n          ")])],1)],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutUs_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c111d2d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutUs_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c111d2d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    backgroundImage: 'url(' + _vm.bg + ')',
    backgroundPosition: 'center',
  })},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-card',{staticClass:"pa-4 mb-2"},[_c('h4',{staticClass:"accent--text"},[_vm._v("What is ELITE?")]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2 ml-3",staticStyle:{"ext-align":"justify"}},[_vm._v("\n            As a physician, you are busy in your clinical practice, that\n            attending trainings, seminars, or conferences to earn Continuing\n            Professional Development (“CPD”) units may be a challenge. This\n            ELITE Website provides the solution as it is an online learning\n            platform on thyroid disorders that is accessible physicians in the\n            Philippines.\n          ")]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2 ml-3",staticStyle:{"ext-align":"justify"}},[_vm._v("\n            The ELITE Website provides free CPD units to Filipino physicians\n            with PRC ID who register and complete the modules as well as pass\n            the online examination.\n          ")])]),_vm._v(" "),_c('v-card',{staticClass:"pa-4 mb-2"},[_c('h4',{staticClass:"accent--text"},[_vm._v("How to have full access?")]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2 ml-3",staticStyle:{"ext-align":"justify"}},[_vm._v("\n            You must register in the ELITE Website to gain full access.\n            Registration is simple and is done by providing the Professional\n            Regulatory Commission (“PRC”) details such as the physician’s\n            name, PRC registration number, date of registration and email\n            address.\n          ")])]),_vm._v(" "),_c('v-card',{staticClass:"pa-4 mb-2"},[_c('h4',{staticClass:"accent--text"},[_vm._v("How to earn CPD units?")]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2 ml-3",staticStyle:{"ext-align":"justify"}},[_vm._v("\n            After registering, the physician will have access to all modules\n            on thyroid disorders, prediabetes and diabetes, and cardiovascular\n            diseases. To earn a CPD point, one must finish the module and pass\n            an online examination for each module.\n          ")]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2 ml-3",staticStyle:{"ext-align":"justify"}},[_vm._v("\n            The CPD unit provided by this website is for Filipino physicians\n            who have PRC ID.\n          ")])]),_vm._v(" "),_c('v-card',{staticClass:"pa-4 mb-2"},[_c('h4',{staticClass:"accent--text"},[_vm._v("FAQs.")]),_vm._v(" "),_c('v-container',{staticClass:"ml-4"},[_c('ol',[_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("What will happen if the healthcare professional does not\n                  pass the online examination for a module?")])]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2"},[_vm._v("\n                The physician may take the online exam several times until one\n                passes.\n              ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("Is there a possibility that PRC (or the applicable\n                  regulatory agency) will not honor the units earned by the\n                  healthcare professional?")])]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2"},[_vm._v("\n                Yes, this is possible if the details provided by the physician\n                were incorrect, thus could not be verified by the applicable\n                regulatory agency.\n              ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("Can the healthcare professional take the module and online\n                  examination after s/he earned the CPD (or their relevant\n                  equivalent) units to earn additional units?")])]),_vm._v(" "),_c('p',{staticClass:"body-2 mt-2"},[_vm._v("\n                No. After earning gaining all the CPD units, the physician can\n                no longer earn additional units by viewing the module and\n                taking the online exam again. The units from these modules may\n                only be earned once.\n              ")])])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webinar_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4f48e9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webinar_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d4f48e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webinar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4f48e9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webinar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundImage: 'url(' + _vm.bg + ')', backgroundPosition: 'center' })},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-card',[_c('v-layout',{staticClass:"mb-3",attrs:{"align-center":"","justify-center":"","wrap":""}},[_c('v-flex',{staticClass:"mb-8",style:({position:'relative',left:'5%'}),attrs:{"md4":"","order-sm2":""}},[_c('strong',[_c('span',{staticClass:"primary--text"},[_c('b',[_vm._v(_vm._s(_vm.recordedWebinars.length))])]),_vm._v(" "),_c('span',[_vm._v(" Recorded added since")])]),_vm._v(" "),_c('span',[_vm._v("as of "+_vm._s(_vm.recordedWebinars.length > 0 ? _vm.convertDate(_vm.recordedWebinars[0].created_at) : "")+"\n            ")])]),_vm._v(" "),_c('v-flex',{staticClass:"mb-8",style:({position:'relative',left:'5%'}),attrs:{"md4":"","order-sm2":"","id":"searchField"}},[_c('v-text-field',{style:({width:'90%'}),attrs:{"solo":"","label":"Search Webinar","prepend-icon":"search"},on:{"input":_vm.handleChange},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-8",attrs:{"md4":"","order-sm2":""}},[_c('center',[_c('v-select',{style:({width:'50%'}),attrs:{"items":_vm.filterTypes,"label":"Category"},on:{"change":_vm.handleFilter},model:{value:(_vm.categoryText),callback:function ($$v) {_vm.categoryText=$$v},expression:"categoryText"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"pa-4 mb-2"},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('h1',[_vm._v("View Recorded Webinars Below")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-data-iterator',{attrs:{"content-tag":"v-layout","row":"","wrap":"","items":_vm.searchRecorded,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(webinar){return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg4":""}},[_c('v-card',{attrs:{"hover":""},nativeOn:{"click":function($event){return _vm.handleClick(webinar.item)}}},[_c('v-card-media',{style:({backgroundSize: 'contain'}),attrs:{"src":_vm.filesUrl + webinar.item.image,"height":"200"}}),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('span',{style:({fontSize: '70%'})},[_c('strong',[_vm._v(_vm._s(webinar.item.title))])]),_vm._v(" "),_c('span',{style:({fontSize: '55%'})},[_vm._v("\n                      "+_vm._s(webinar.item.description)+"\n                    ")]),_vm._v(" "),_c('span',{style:({fontSize: '50%'})},[_c('b',{staticClass:"accent--text"},[_vm._v(_vm._s(webinar.item.category))]),_vm._v(" · "+_vm._s(_vm.convertDate(webinar.item.created_at)))]),_vm._v(" "),_c('span',{style:({fontSize: '55%'})},[_vm._v("\n                      "+_vm._s(webinar.item.code)+"\n                    ")])])],1)],1),_vm._v(" "),_c('v-card-text')],1)],1)}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedWebinar.title))]),_vm._v(" "),_c('div',[_c('Media',{style:({width: '500px'}),attrs:{"kind":'video',"controls":true,"src":[_vm.filesUrl + _vm.selectedWebinar.video]}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n                Close\n              ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webinar_links_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d728327_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webinar_links_vue__ = __webpack_require__(355);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d728327"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webinar_links_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d728327_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webinar_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    backgroundImage: 'url(' + _vm.bg + ')',
    backgroundPosition: 'center',
  })},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-card',{staticClass:"pa-4 mb-2"},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('h1',[_vm._v("Use the following link to download the Thyroid Cheat Cards.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-card',{staticClass:"pa-4 mb-2"},[_c('v-list',{attrs:{"two-line":"","subheader":""}},_vm._l((_vm.searchLinked),function(webinar,i){return _c('v-list-tile',{key:i,attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":webinar.url,"target":"_blank"}},[_vm._v("\n                      "+_vm._s(webinar.title)+"\n                    ")])]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"accent--text"},[_vm._v(_vm._s(webinar.category))]),_vm._v(" "),_c('span',[_vm._v(" - ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.convertDate(webinar.created_at)))])])],1)],1)}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedWebinar.title))]),_vm._v(" "),_c('div',[_c('Media',{style:({ width: '500px' }),attrs:{"kind":'video',"controls":true,"src":[_vm.url + _vm.selectedWebinar.video]}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n              Close\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('keep-alive',[_c('dashboard-header',{staticClass:"white",attrs:{"doctorName":_vm.doctorName}})],1),_vm._v(" "),_c('div',{staticClass:"white"},[_c('v-container',{staticClass:"white mb-3"},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{staticClass:"display-1"},[_c('strong',[_vm._v("Your Dashboard")])]),_vm._v(" "),_c('v-flex',{attrs:{"text-md-right":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"text-xs-right":""}},[_c('strong',[_vm._v("CPD Points")]),_vm._v(" "),_c('div',[_c('em',[_vm._v("as of "+_vm._s(_vm.dateToday))])])]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-avatar',{attrs:{"color":"primary"}},[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(_vm.totalCpdPoints))])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","flat":"","centered":"","color":"white","slider-color":"primary"},slot:"extension",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.tabs),function(tab,i){return _c('v-tab',{key:i,attrs:{"href":("#tab-" + (tab.value))}},[_vm._v("\n        "+_vm._s(tab.text)+"\n      ")])}),1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.tabs),function(tab,i){return _c('v-tab-item',{key:i,attrs:{"id":("tab-" + (tab.value))}},[_c(tab.component,{tag:"component",attrs:{"modules":_vm.modules,"watchlist":_vm.watchlist,"addToWatchlist":_vm.addToWatchlist,"removeToWatchList":_vm.removeToWatchList,"user":_vm.user,"activities":_vm.activities,"certificates":_vm.certificates}})],1)}),1),_vm._v(" "),_c('v-footer',{attrs:{"height":"112"}},[_c('main-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35949165_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(363);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35949165_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messagingFeature_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3127576e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messagingFeature_vue__ = __webpack_require__(359);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messagingFeature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3127576e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messagingFeature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',[_c('v-btn',{on:{"click":_vm.showMessaging}},[_vm._v("Leave a Message to Author")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n            Leave a Message\n          ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"hide-details":"","textarea":""},model:{value:(_vm.messageToAuthor),callback:function ($$v) {_vm.messageToAuthor=$$v},expression:"messageToAuthor"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.submitMessage($event)}}},[_vm._v("Submit")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,index){return [(item.header)?_c('v-subheader',{key:item.header},[_vm._v(_vm._s(item.header))]):(item.divider)?_c('v-divider',{key:index,attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.title,attrs:{"avatar":""}},[_c('v-list-tile-avatar',{attrs:{"color":"primary primary--lighten-2"}},[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(item.initials))])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedModules_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_509ba55e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatedModules_vue__ = __webpack_require__(361);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedModules_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_509ba55e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatedModules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',[_c('div',{staticClass:"display-1 mb-5"},[_c('strong',[_vm._v("Related Modules")])])]),_vm._v(" "),_c('v-layout',_vm._l((_vm.relatedModules),function(module,i){return _c('v-flex',{key:i,attrs:{"md4":""}},[_c('v-card',{attrs:{"hover":""},nativeOn:{"click":function($event){return _vm.handleClick(module.id)}}},[_c('v-card-media',{attrs:{"src":module.media,"height":"200"}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"title mb-3"},[_vm._v(_vm._s(module.title))]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_vm._v(_vm._s(module.subtitle))]),_vm._v(" "),_c('strong',[_c('span',[_vm._v("CPD Points")]),_vm._v(" "),_c('v-avatar',{attrs:{"color":"primary","size":"30"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(module.points))])])],1)])])],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjE5MDIgNjExMiA0My41NyA1MC41ODUiPg0KICA8ZGVmcz4NCiAgICA8c3R5bGU+DQogICAgICAuY2xzLTEgew0KICAgICAgICBmaWxsOiAjYjViNWI1Ow0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPGcgaWQ9Ikdyb3VwXzI3NSIgZGF0YS1uYW1lPSJHcm91cCAyNzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNTQgNDYwNCkiPg0KICAgIDxwYXRoIGlkPSJQYXRoXzYzOSIgZGF0YS1uYW1lPSJQYXRoIDYzOSIgY2xhc3M9ImNscy0xIiBkPSJNNjMuMTk0LDE5LjkzMkg1Ny4yODZ2My42OTJoNC4wNjJ2Ni45NTRhMTEuMDc3LDExLjA3NywwLDAsMS0yMi4xNTQsMFYyMy42MjRoMy45MzlWMTkuOTMySDM3LjM0N0ExLjg0NiwxLjg0NiwwLDAsMCwzNS41LDIxLjc3OHY4LjhhMTQuNzY5LDE0Ljc2OSwwLDEsMCwyOS41MzksMHYtOC44QTEuODQ2LDEuODQ2LDAsMCwwLDYzLjE5NCwxOS45MzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MTIuNDk5IDE0OTAuMDM3KSIvPg0KICAgIDxwYXRoIGlkPSJQYXRoXzY0MCIgZGF0YS1uYW1lPSJQYXRoIDY0MCIgY2xhc3M9ImNscy0xIiBkPSJNMTg2LjU4OCwyNjIuNDM3djguNzM5YTkuMjMxLDkuMjMxLDAsMCwxLTE4LjQ2MiwwVjI1OS4xMTRoLTMuNjkydjEyLjA2MmExMi45MjMsMTIuOTIzLDAsMCwwLDI1Ljg0Niwwdi04LjczOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM5Ni4zMDUgMTI3NC40ODYpIi8+DQogICAgPHBhdGggaWQ9IlBhdGhfNjQxIiBkYXRhLW5hbWU9IlBhdGggNjQxIiBjbGFzcz0iY2xzLTEiIGQ9Ik0zNDUuMDQ3LDE3MS45MTJhNi44MzEsNi44MzEsMCwxLDAsNi44MzEsNi44MzFBNi44MzgsNi44MzgsMCwwLDAsMzQ1LjA0NywxNzEuOTEyWm0wLDkuOTY5YTMuMTM4LDMuMTM4LDAsMSwxLDMuMTM4LTMuMTM4QTMuMTQyLDMuMTQyLDAsMCwxLDM0NS4wNDcsMTgxLjg4MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzOS42OTIgMTM1My4wNzMpIi8+DQogICAgPHBhdGggaWQ9IlBhdGhfNjQyIiBkYXRhLW5hbWU9IlBhdGggNjQyIiBjbGFzcz0iY2xzLTEiIGQ9Ik05NS4yNzQsMGExLjg0NiwxLjg0NiwwLDAsMC0xLjg0NiwxLjg0NlY1Ljc4NWExLjg0NiwxLjg0NiwwLDAsMCwzLjY5MiwwVjEuODQ2QTEuODQ2LDEuODQ2LDAsMCwwLDk1LjI3NCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDYwLjI5NSAxNTA4KSIvPg0KICAgIDxwYXRoIGlkPSJQYXRoXzY0MyIgZGF0YS1uYW1lPSJQYXRoIDY0MyIgY2xhc3M9ImNscy0xIiBkPSJNMjM5Ljc4LDBhMS44NDYsMS44NDYsMCwwLDAtMS44NDYsMS44NDZWNS43ODVhMS44NDYsMS44NDYsMCwwLDAsMy42OTIsMFYxLjg0NkExLjg0NiwxLjg0NiwwLDAsMCwyMzkuNzgsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMC4wNjYgMTUwOCkiLz4NCiAgPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dashboard-header',{staticClass:"white elevation-1",attrs:{"doctorName":_vm.doctorName}}),_vm._v(" "),_c('v-container',{staticClass:"mb-3"},[_c('v-card',{staticClass:"pa-5"},[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"display-1 mb-3"},[_c('strong',{staticStyle:{"color":"#800080","text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.moduleData.title))])]),_vm._v(" "),_c('div',{staticClass:"subtitle mb-5"},[_vm._v("\n            "+_vm._s(_vm.moduleData.description)),_c('br'),_vm._v(" "),_c('span',[_vm._v("Author: ")]),_c('span',{staticStyle:{"color":"#ee44aa"}},[_vm._v(_vm._s(_vm.moduleData.author))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"text-md-right":""}},[(_vm.proceedToExam)?_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.goToExam($event)}}},[_vm._v("Proceed to Exam")]):_vm._e()],1)],1),_vm._v(" "),_c('v-jumbotron',{attrs:{"dark":""}},[_c('v-container',{staticClass:"pa-0",attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"md12":"","fill-height":"","text-xs-center":""}},[_c('video',{ref:"video",style:({ backgroundColor: 'black', cursor: 'pointer' }),attrs:{"height":"100%","width":"100%","preload":"auto","controlsList":"nodownload","src":_vm.moduleData.video,"poster":_vm.moduleData.image},on:{"click":_vm.handleVideoClick}},[_vm._v("\n                Your browser does not support the video tag.\n              ")]),_vm._v(" "),(_vm.videoPaused)?_c('v-layout',[_c('v-flex',[_c('div',{style:({ position: 'absolute', top: '31%', left: '45%', cursor: 'pointer' }),on:{"click":_vm.handleVideoClick}},[_c('v-icon',{style:({ fontSize: '8em', background: '#8e8e8e' })},[_vm._v("mdi-play-box-outline")])],1)]),_vm._v(" "),_c('v-flex',[_c('div',{style:({ position: 'absolute', bottom: '10px', right: '10px', cursor: 'pointer',background: '#8e8e8e' }),on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleClickFullscreen($event)}}},[_c('v-icon',{style:({ fontSize: '4em' })},[_vm._v("mdi-fullscreen")])],1)])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"text-md-right":""}},[_c('span',[_vm._v("CPD Points")]),_vm._v(" "),_c('v-avatar',{attrs:{"color":"primary","size":"30"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.moduleData.cpd_points))])])],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"mb-3"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-right":""}},[_c('v-btn',{staticClass:"secondary secondary--text",attrs:{"outline":"","to":"/dashboard"}},[_vm._v("\n          Back\n        ")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-footer',{attrs:{"height":"112"}},[_c('main-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bfb7093_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(368);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bfb7093_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assessmentResult_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e4f114_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assessmentResult_vue__ = __webpack_require__(366);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assessmentResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e4f114_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assessmentResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5"},[_c('v-layout',[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('div',{staticClass:"display-2 mb-3"},[(_vm.totalModule > _vm.completion)?_c('strong',[_vm._v(_vm._s(_vm.score >= _vm.minimum ? 'Good Job' : 'Not Passed'))]):_c('strong',[_vm._v("Congratulations!")])]),_vm._v(" "),_c('div',{staticClass:"title mb-5"},[_c('span',{staticClass:"secondary--text"},[_vm._v("Congratulations. You have just earned 1 CPD unit for completing this module. Please don't forget to share your feedback on your experience.")])]),_vm._v(" "),(_vm.completion >= _vm.totalModule)?_c('div',{staticClass:"mb-3"},[_c('div',[_vm._v("We want to kindly ask you to fill in the following short questionnaire")]),_vm._v(" "),_c('div',[_vm._v("We highly value your feedback on Merck")]),_vm._v(" "),_c('div',[_vm._v("Please Click "),_c('a',{attrs:{"href":"https://docs.google.com/forms/d/e/1FAIpQLScWTZpNcwuANyhPFZT0sifQ_IjGlIPZf3GNwZon-8Ab_tSxOg/viewform","target":"_blank"}},[_vm._v("here")])])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.score >= _vm.minimum)?_c('v-btn',{staticClass:"secondary",attrs:{"large":"","light":"","outline":"","to":"/dashboard"}},[_vm._v("\n          Home\n        ")]):_vm._e(),_vm._v(" "),(_vm.score < _vm.minimum)?_c('v-btn',{staticClass:"secondary",attrs:{"large":"","light":"","outline":""},on:{"click":this.retry}},[_vm._v("\n          Retry\n        ")]):_vm._e(),_vm._v(" "),(_vm.score < _vm.minimum)?_c('v-btn',{staticClass:"secondary",attrs:{"large":"","light":"","outline":""},on:{"click":this.reviewModule}},[_vm._v("\n          Review Module\n        ")]):_vm._e(),_vm._v(" "),(_vm.certificateCode)?_c('v-btn',{staticClass:"accent",attrs:{"large":"","flat":"","to":("/certificate/" + _vm.certificateCode)}},[_vm._v("\n          View Certificate\n        ")]):_vm._e()],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/water_4.3528fce.png";

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    backgroundImage: 'url(' + _vm.bg + ')',
    backgroundPosition: 'center',
  })},[_c('dashboard-header',{staticClass:"white"}),_vm._v(" "),_c('v-container',[_c('v-card',[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"display-3 mb-3"},[_c('strong',[_vm._v("Mandatory Assessment")])]),_vm._v(" "),_c('p',{staticClass:"title grey--text text--lighten-1"},[_vm._v("\n              You need to answer each question correctly before you can\n              proceed to the next item. You can earn the CPD units once you\n              have completed the entire course.\n            ")])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-form',[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_vm._l((_vm.steps),function(n){return [_c('v-stepper-step',{key:(n + "-step"),attrs:{"step":n,"complete":_vm.e1 > n,"rules":[function () { return _vm.validAnswer !== n; }]}},[(_vm.validAnswer === n)?_c('small',[_vm._v("Invalid answer")]):_vm._e()]),_vm._v(" "),(n !== _vm.steps)?_c('v-divider',{key:n}):_vm._e()]})],2),_vm._v(" "),_c('v-stepper-items',_vm._l((_vm.selectedQuestions),function(question,q){return _c('v-stepper-content',{key:(q + "-content"),attrs:{"step":q + 1}},[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('strong',[_vm._v("Question "+_vm._s(q + 1))])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(question.question)}})]),_vm._v(" "),_c('v-radio-group',{model:{value:(_vm.radioGroup[q]),callback:function ($$v) {_vm.$set(_vm.radioGroup, q, $$v)},expression:"radioGroup[q]"}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((question.choices),function(choice,c){return _c('v-flex',{key:c,attrs:{"xs12":""}},[_c('v-radio',{attrs:{"label":choice.label,"value":choice}})],1)}),1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.nextStep(q + 1, q)}}},[(q + 1 < _vm.steps)?_c('div',[_vm._v("Next")]):_c('div',[_vm._v("Submit")])])],1)],1)],1)],1)}),1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"height":"112"}},[_c('main-footer')],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1000","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('assessment-result',{attrs:{"score":_vm.score,"minimum":_vm.parseNumber(_vm.module.minimum_score),"total":_vm.steps,"points":_vm.points,"retry":_vm.retry,"reviewModule":_vm.reviewModule,"certificateCode":_vm.certificateCode,"completion":_vm.completion,"totalModule":_vm.totalModule}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a039264_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(374);
function injectStyle (ssrContext) {
  __webpack_require__(370)
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a039264_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NzguNDkgNzUuNjciPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojNTAzMzhmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+TWVyY2sgTG9nbzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iTGF5ZXJfMS0zIiBkYXRhLW5hbWU9IkxheWVyXzEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEuMjQsMWMtMS40LDMuMi0xLDguMi0uOSwxMS42djMzYzAsMTYuMi00LDMwLjQsMTUuNSwyOS4xLDYuNS0uNCw0LjctMy4zLDQuNi0xNy4xLS4yLTMwLjMsMjQuNS0xMy44LDM0LjgtMi41YTgwLjE4LDgwLjE4LDAsMCwwLDEyLjQsMTAuN2M1LjMsMy42LDkuOCw1LjIsMTYuNCwyLjIsNS45LTIuNiwxMy43LTEwLjMsMTguMS0xNSwzLjgtNCwxMy43LTEyLjEsMjAuNi0xMi41LDE4LjUtMS4zLDguMywyMiwxNC4zLDI5LjcsMy42LDQuNywxMC4yLDUuMywxNy4xLDRsLjMtLjkuNy0yMy43YzAtOC44LDIuMy00MS4zLTMuMi00Ni4yLTIuOS0yLjYtMTcuMy01LjgtMjIuNy0uM2wtNC43LDQuNGMtOS4xLDcuNy03LjcsNy42LTEyLjgsMTIuMi0yMi4xLDIwLjQtNTAuOCwxOC45LTY4LjYtLjVDMzAuMzQsNS4zMSwyMi4zNC0zLDEuMjQsMVptMzk1LjYsNDIuNmMtNS41LS4xLTE0LjctMS41LTE4LjQsMS45LTQuNCw0LTEuMyw4LjgtOS4zLDEwLjctMTEsMi42LTIwLjctOC41LTIzLjctMTUuNC01LjMtMTEuOC43LTI0LjQsMTQuMy0yMC4zLDEzLjksNC4yLDUuOSwxMi4zLDI0LjgtNS45LTguMS0xNy4yLTQ0LjQtMTQuOS02MC45LTEzLjgtMS42LDcuNS0xLDM2LjMsMS4yLDQzLjUsNi44LDIyLjcsMzMuNiwzOC41LDU1LjUsMjguMUMzODguOTQsNjguNDEsMzk4LjQ0LDU3LjQxLDM5Ni44NCw0My42MVptODAuNSwzMC43YzYuNy0yNC4xLTE3LjktMjEuNy0yMi43LTMwLjYtNC45LTkuMSwxNS45LTE5LjQsMjEuNi0yOS40LDUuMS04LjkuNS0xNS4xLTEwLjMtMTMuMy0xMS43LDEuOS0yNC41LDI0LjQtNDEuOCwzNi41LjItMTUuOSwzLjUtMzIuOC03LjEtMzYuMWwtMTAuMS0uNWMtMi4zLjUtLjgsMC0yLjEuOS0yLjMsMi41LS43LDUzLjYtLjksNjQuOC0uMSw1LTEuMiw3LjEsMi44LDcuOSwxNi43LDMuNCwxNC44LTIwLjIsMzguMy0xMC4yQzQ1My4yNCw2Ny45MSw0NjcuODQsNzUuNzEsNDc3LjM0LDc0LjMxWm0tMjMzLjctLjJjMzEuMiw3LjEsMTEuNC00NS43LDIyLTUzLjUsOC4yLTYsMjQuNy40LDI4LjIsNi45cy0uOCwxMC4yLTYuMywxMS4xYy02LjYsMS4xLTExLjMtMS44LTE3LjMtMi42LDAsMTAuNi0xLjYsMTMuMSw1LjMsMTguNiwyMi4zLDE4LjEsMjIuNywyMS43LDQ2LjksMTkuNywyLjctMTEuMS0xLjItNy4zLTE0LjYtMThsLTUuNS01YzE4LjYtNi43LDE4LjktMjguNSwwLTQxLjVhNTEuNjcsNTEuNjcsMCwwLDAtMjUuOC05LjFjLTcuNS0uNS0yNi43LS44LTMzLjcuMi0xLjQsNS44LS41LDUxLjYtLjYsNjQuN0MyNDIuMzQsNjguNTEsMjQyLjI0LDcxLjcxLDI0My42NCw3NC4xMVptLTguNC4xYzguNS0zMy40LTM1LTcuNi00OC44LTI3LjMtMTguNC0yNi4xLDExLjktMzcsMjcuOC0xNS41bC0yMy42LjNjLTEuOCwxOS4xLDIxLjgsMTUuNywzMC4xLDE1LjcsNy42LDAsMTQuMy45LDE1LTcuOCwxLjQtMTYtMTQuOS0zMi42LTMwLjgtMzcuMy03LjYtMi4zLTM2LjQtMy4yLTQyLjctMS0xLjUsNS4yLTEsMjkuMS0uMywzNiwxLjEsMTAuNyw1LjMsMTcuOSwxMi4yLDI0LjhhNDEsNDEsMCwwLDAsMTAuOCw4LjJDMTk2Ljg0LDc2LjQxLDIyNi43NCw3NS44MSwyMzUuMjQsNzQuMjFaIi8+PC9nPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certificate.17e861b.png";

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dashboard-header'),_vm._v(" "),_c('v-container',{staticClass:"mb-3"},[_c('v-layout',{staticClass:"mb-3 noprint"},[_c('v-flex',{attrs:{"text-md-right":""}},[_c('v-btn',{staticClass:"secondary secondary--text noprint",attrs:{"outline":"","large":"","to":"/dashboard"}},[_vm._v("\n          Home\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"accent noprint",attrs:{"large":""},on:{"click":_vm.handleSaveAsPdf}},[_vm._v("\n          Save as PDF\n        ")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"pa-5 certificate_bg",style:({ backgroundImage: 'url(' + _vm.bg + ')' }),attrs:{"height":"1130"}},[_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"md6":"","xs6":""}},[_c('div',{staticClass:"mb-5"},[_c('img',{attrs:{"src":_vm.logo,"height":"80"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","xs6":"","text-xs-right":""}},[_c('div',{staticClass:"mb-5"},[_c('img',{attrs:{"src":_vm.merckLogo,"height":"30"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('div',{staticClass:"display-3"},[_c('strong',{staticClass:"deep-purple--text darken-2"},[_vm._v("Certificate of Completion")])]),_vm._v(" "),_c('div',{staticClass:"grey--text text--darken-1",style:(_vm.styles.text)},[_vm._v("\n                This certificate is presented to:\n              ")]),_vm._v(" "),_c('div',{staticClass:"display-1 accent--text my-3"},[_c('strong',{staticStyle:{"font-size":"26px"}},[_vm._v("DR. "+_vm._s(_vm.user.firstname.toUpperCase())+" "+_vm._s(_vm.user.middlename.toUpperCase())+" "+_vm._s(_vm.user.lastname.toUpperCase()))])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-divider')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","text-xs-center":""}},[_c('p',{staticClass:"grey--text text--darken-1",style:(_vm.styles.text)},[_vm._v("\n                for successfully completing the course on\n                "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"25px"}},[_c('span',{staticClass:"deep-purple--text darken-2",staticStyle:{"text-transform":"uppercase","font-weight":"bold"}},[_vm._v(_vm._s(_vm.moduleTitle))])]),_vm._v(" "),_c('br'),_vm._v("\n                Issued on : "+_vm._s(_vm.dateToday)+"\n                "),_c('br'),_vm._v(" "),_c('small',[_c('span',{staticClass:"accent--text",staticStyle:{"font-weight":"bold"}},[_vm._v("1 CDP Unit")])])]),_c('div',[_c('small',[_vm._v("(Ref No. "+_vm._s(_vm.moduleCodes)+")")])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Elite Online: "+_vm._s(_vm.certificateCode))])]),_vm._v(" "),_c('p')])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"noprint"},[_c('v-flex',[_c('v-btn',{attrs:{"color":"blue","block":"","flat":"","large":""},on:{"click":_vm.shareToFb}},[_c('span',[_vm._v("Share to Facebook")])])],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"noprint",attrs:{"height":"112"}},[_c('main-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e87760c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(385);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e87760c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teofilo_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad78a50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teofilo_vue__ = __webpack_require__(378);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teofilo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad78a50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teofilo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/teofilo-san-luis-jr.d9e743e.jpg";

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5 author-v-card"},[_c('v-container',[_c('v-layout',{staticClass:"mb-4",attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("TEOFILO O.L. SAN LUIS, JR., MD")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('img',{staticClass:"image-author",attrs:{"src":_vm.author,"width":"300"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('div',[_c('p',{staticClass:"subheading"},[_c('i',{staticClass:"purple--text"},[_vm._v("National Coordinator Iodine Global Network (IGN) —\n              Philippines.")])]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            Dr. Teofilo O.L. San Luis Jr. obtained his degree of Doctor of\n            Medicine at the University of Santo Tomas (UST) Faculty of\n            Medicine and Surgery. He subsequently had his fellowship training\n            in Nuclear Medicine, Institute for Clinical & Experimental Nuclear\n            Medicine at University of Bonn, Germany. Subsequently, he had his\n            research fellowship on Thyroidology at Klinikum Steglitz in\n            Germany and on Autoimmune Thyroid Diseases at Gifu University in\n            Japan. He is a graduate of Master of Arts in Public Administration\n            at UST and took a course on Managing Health Programs in Developing\n            Countries, at Harvard University School of Public Health in\n            Boston, USA.\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is a former Professor of UST Faculty of Medicine & Surgery,\n            former Dean of St. Luke’s College of Medicine – William H. Quasha\n            Memorial and former Dean of Asian School of Nuclear Medicine.\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is a Past President of the Philippine Thyroid Association\n            (PTA), Examiner of Asian Nuclear Medicine Board , Asian\n            Cooperative Council for Nuclear Medicine (ARCCNM) and Course\n            Director for various International Atomic Energy Agency (IAEA)\n            Regional & National Training Course in Oncology, Thyroidology,\n            Cardiology, Neurology & related Specialties and on Quality\n            Management (QUANUM), held in Costa Rica, Morocco, Tanzania, Iran &\n            the Philippines. In the Asia-Oceania Thyroid Association (AOTA) he\n            served as Secretary (2010-2015) then Vice President (2015-2021).\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is the National Coordinator for the Philippines of the Iodine\n            Global Network (IGN); an active member of ThyroWorld Editorial\n            Board of Thyroid Federation International (TFI), member of the\n            Technical Working Group of National Salt Iodization Program of\n            Department of Health (DOH) National Nutrition Council and member\n            of Technical Working Group of DOH Thyroid Disease Prevention &\n            Control Program. He also holds a post as National Project\n            Coordinator of Philippine Nuclear Research Institute (PNRI)\n            PHI6025 Project. He is an active Faculty in the Department of\n            Professionalism, Medical Ethics & Humanities of the St Luke's\n            Medical Center College of Medicine - William H Quasha Memorial.\n          ")])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-md-right":""}},[_c('v-btn',{staticClass:"accent",attrs:{"large":"","to":"/dashboard"}},[_vm._v(" Back ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kho_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15db0222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kho_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kho_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15db0222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kho_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sjoberg_kho.c80e3f1.jpg";

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5 author-v-card"},[_c('v-container',[_c('v-layout',{staticClass:"mb-4",attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("SJOBERG ANG KHO, M.D.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('img',{staticClass:"image-author",attrs:{"src":_vm.author,"width":"300"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('div',[_c('p',{staticClass:"subheading"},[_c('i',{staticClass:"purple--text"},[_vm._v("Associate Professor, University of Santo Tomas — Faculty of Medicine and Surgery")])]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v(" \n            Dr. Sjoberg Kho obtained his fellowship training in Diabetes, Endocrinology and Metabolism at University Hospital at The State University of New York (SUNY) in Stony Brook, New York and became the Chief Resident of the Department of  Internal Medicine  in the same institution.\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is a Past President of the Philippine Society of Endocrinology and Metabolism (PSEDM) and former Residency Training Officer of the UST Faculty of Medicine and Surgery and Assistant Chairman of UST Department of Medicine.\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is currently a Board of the Philippine Thyroid Association (PTA), Head of the UST Hospital Diabetes Center and Chief of UST Hospital Section of Endocrinology & Metabolism.\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is an Associate Professor of the UST Faculty of Medicine & Surgery and the Chief, Section of Endocrinology & Metabolism, of  The same institution.\n          ")])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-md-right":""}},[_c('v-btn',{staticClass:"accent",attrs:{"large":"","to":"/dashboard"}},[_vm._v("\n          Back\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nicodemus_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57daa98d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nicodemus_vue__ = __webpack_require__(384);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nicodemus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57daa98d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nicodemus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tsl_2017.04a6008.png";

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5 author-v-card"},[_c('v-container',[_c('v-layout',{staticClass:"mb-4",attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("NEMENCIO ALMARE NICODEMUS JR., MD")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('img',{staticClass:"image-author",attrs:{"src":"/static/img/dr_nicodemus_2016.jpg","width":"300"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('div',[_c('p',{staticClass:"subheading font-italic"},[_c('i',{staticClass:"purple--text"},[_vm._v("Professor, University of the Philippines — College of Medicine")])]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            Dr. Nemencio Nicodemus Jr. obtained his degree of Doctor of Medicine at the University of the Philippines-College of Medicine. He subsequently completed his residency training in Internal Medicine and fellowship training in Endocrinology, Diabetes and Metabolism at the Philippine General Hospital. Subsequently, he went to the Mayo Clinic in Rochester, Minnesota as part of the Visiting Clinician Program.\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is a Professor at the University of the Philippines-College of Medicine, Department of Biochemistry & Molecular Biology. He is also a Clinical Professor at the Department of Medicine of the Philippine General Hospital, Division of Endocrinology, Diabetes & Metabolism.\n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is a Council Member of the Asia & Oceania Thyroid Association (AOTA), President of the Philippine Association for The Study of Overweight and Obesity (PASOO) and Regent of the Philippine College of Physicians. \n          ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("\n            He is a Past President of the Philippine Society of Endocrinology, Diabetes and Metabolism (PSEDM) and Philippine Thyroid Association (PTA).\n          ")])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-md-right":""}},[_c('v-btn',{staticClass:"accent",attrs:{"large":"","to":"/dashboard"}},[_vm._v("\n          Back\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dashboard-header'),_vm._v(" "),_c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c(_vm.author,{tag:"component"})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27710ea2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(392);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27710ea2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addModuleForm_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c47af1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addModuleForm_vue__ = __webpack_require__(390);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addModuleForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c47af1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addModuleForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multipleSegment_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb1a7ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multipleSegment_vue__ = __webpack_require__(389);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multipleSegment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb1a7ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multipleSegment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Start time"},on:{"input":_vm.onChangeInput},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"End time"},on:{"input":_vm.onChangeInput},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Title"},on:{"input":_vm.onChangeInput},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Description"},on:{"input":_vm.onChangeInput},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[(_vm.index === _vm.totalIndex - 1)?_c('v-btn',{attrs:{"color":"primary","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.addToArray($event)}}},[_c('v-icon',[_vm._v("add")])],1):_c('v-btn',{attrs:{"color":"primary","fab":"","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.removeDataToArray(_vm.index)}}},[_c('v-icon',[_vm._v("remove")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"height":"1400px"}},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Author","required":""},model:{value:(_vm.author),callback:function ($$v) {_vm.author=$$v},expression:"author"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.pickVideoFile}},[_c('v-icon',{attrs:{"color":"accent"}},[_vm._v("videocam")]),_vm._v(" "),_c('strong',{staticClass:"accent--text"},[_vm._v("Change Video")])],1),_vm._v(" "),_c('input',{ref:"inputVideoFile",style:({ display: 'none' }),attrs:{"type":"file","accept":"video/*"},on:{"change":_vm.onVideoFilePicked}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.pickImageFile}},[_c('v-icon',{attrs:{"color":"accent"}},[_vm._v("photo_camera")]),_vm._v(" "),_c('strong',{staticClass:"accent--text"},[_vm._v("Change Photo")])],1),_vm._v(" "),_c('input',{ref:"inputImageFile",style:({ display: 'none' }),attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onImageFilePicked}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"CPD Points","required":""},model:{value:(_vm.cpdPoints),callback:function ($$v) {_vm.cpdPoints=$$v},expression:"cpdPoints"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Description","required":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Category","required":""},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Minimum Score","required":""},model:{value:(_vm.minimumScore),callback:function ($$v) {_vm.minimumScore=$$v},expression:"minimumScore"}})],1)],1),_vm._v(" "),_c('h5',[_vm._v("Video Segments")]),_vm._v(" "),_vm._l((_vm.segmentData),function(seg,i){return _c('div',[_c('multiple-segment',{attrs:{"index":i,"totalIndex":_vm.segmentData.length,"dataStartTime":seg.start_time,"dataEndTime":seg.end_time,"dataTitle":seg.title,"dataDescription":seg.description,"addToArray":_vm.addToArray,"removeToArray":_vm.removeToArray,"updateMultipleSegment":_vm.updateMultipleSegment}})],1)}),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.formValid},on:{"click":_vm.onSubmit}},[_vm._v("\n          Submit\n        ")])],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */,
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Date Start","prepend-icon":"event","readonly":""},model:{value:(_vm.dateRange.start),callback:function ($$v) {_vm.$set(_vm.dateRange, "start", $$v)},expression:"dateRange.start"}},on))]}}]),model:{value:(_vm.uFormModal),callback:function ($$v) {_vm.uFormModal=$$v},expression:"uFormModal"}},[_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.uFormModal = false}},model:{value:(_vm.dateRange.start),callback:function ($$v) {_vm.$set(_vm.dateRange, "start", $$v)},expression:"dateRange.start"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Date End","prepend-icon":"event","readonly":""},model:{value:(_vm.dateRange.end),callback:function ($$v) {_vm.$set(_vm.dateRange, "end", $$v)},expression:"dateRange.end"}},on))]}}]),model:{value:(_vm.uEndModal),callback:function ($$v) {_vm.uEndModal=$$v},expression:"uEndModal"}},[_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.uEndModal = false}},model:{value:(_vm.dateRange.end),callback:function ($$v) {_vm.$set(_vm.dateRange, "end", $$v)},expression:"dateRange.end"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.onLoading},on:{"click":function($event){return _vm.generateData('user')}}},[_vm._v("Generate Users")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.onLoading},on:{"click":function($event){return _vm.generateData('assessment')}}},[_vm._v("Generate assessment")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.onLoading},on:{"click":function($event){return _vm.generateData('certificate')}}},[_vm._v("Generate certificate")]),_vm._v(" "),(_vm.csvData.userData.length > 0)?_c('download-csv',{attrs:{"data":_vm.csvData.userData,"name":"users.csv"}},[_c('v-btn',{attrs:{"color":"success"}},[_vm._v("Download Users")])],1):_vm._e(),_vm._v(" "),(_vm.csvData.assessData.length > 0)?_c('download-csv',{attrs:{"data":_vm.csvData.assessData,"name":"assessment.csv"}},[_c('v-btn',{attrs:{"color":"success"}},[_vm._v("Download assessment")])],1):_vm._e(),_vm._v(" "),(_vm.csvData.certData.length > 0)?_c('download-csv',{attrs:{"data":_vm.csvData.certData,"name":"certificate.csv"}},[_c('v-btn',{attrs:{"color":"success"}},[_vm._v("Download certificate")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","overlay":false,"scrollable":""},model:{value:(_vm.dialogFormModule),callback:function ($$v) {_vm.dialogFormModule=$$v},expression:"dialogFormModule"}},[_c('add-module-form',{attrs:{"apiUrl":_vm.apiUrl}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.dialogWebinar),callback:function ($$v) {_vm.dialogWebinar=$$v},expression:"dialogWebinar"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Webinar")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-flex',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":"Title *","required":""},model:{value:(_vm.submitData.title),callback:function ($$v) {_vm.$set(_vm.submitData, "title", $$v)},expression:"submitData.title"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":"Description *","hint":"example of helper text only on focus","required":""},model:{value:(_vm.submitData.description),callback:function ($$v) {_vm.$set(_vm.submitData, "description", $$v)},expression:"submitData.description"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":"Category *","required":""},model:{value:(_vm.submitData.category),callback:function ($$v) {_vm.$set(_vm.submitData, "category", $$v)},expression:"submitData.category"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-radio-group',{model:{value:(_vm.submitData.is_recorded),callback:function ($$v) {_vm.$set(_vm.submitData, "is_recorded", $$v)},expression:"submitData.is_recorded"}},[_c('v-radio',{key:0,attrs:{"label":"Link","value":0}}),_vm._v(" "),_c('v-radio',{key:1,attrs:{"label":"Recorded","value":1}})],1)],1),_vm._v(" "),(_vm.submitData.is_recorded === 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Url*","required":""},model:{value:(_vm.submitData.url),callback:function ($$v) {_vm.$set(_vm.submitData, "url", $$v)},expression:"submitData.url"}})],1):_vm._e(),_vm._v(" "),(_vm.submitData.is_recorded === 1)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-flex',{staticClass:"text-xs-center text-sm-center text-md-center text-lg-center",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Select Video *","prepend-icon":"attach_file"},on:{"click":_vm.pickFileVideo},model:{value:(_vm.videoName),callback:function ($$v) {_vm.videoName=$$v},expression:"videoName"}}),_vm._v(" "),_c('input',{ref:"video",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"video/*"},on:{"change":_vm.onFilePickedVideo}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',[_c('v-flex',{staticClass:"text-xs-center text-sm-center text-md-center text-lg-center",attrs:{"xs12":""}},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"height":"150"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Select Image *","prepend-icon":"attach_file"},on:{"click":_vm.pickFile},model:{value:(_vm.imageName),callback:function ($$v) {_vm.imageName=$$v},expression:"imageName"}}),_vm._v(" "),_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1),_vm._v(" "),_c('div',[_c('v-alert',{attrs:{"value":this.hasError,"type":"error"}},[_vm._v("\n          Please complete fields.\n        ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":this.isSaving,"text":""},on:{"click":function($event){_vm.dialogWebinar = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","loading":this.isSaving,"text":""},on:{"click":function($event){return _vm.handleSubmitWebinar()}}},[_vm._v("Submit")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8d4f2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(402);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8d4f2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addQuestionForm_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc38326a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addQuestionForm_vue__ = __webpack_require__(395);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addQuestionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc38326a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addQuestionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-form',[_c('v-card-text',[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Question...","required":""},model:{value:(_vm.question),callback:function ($$v) {_vm.question=$$v},expression:"question"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Submit")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d20b49_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(401);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d20b49_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_choice_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6dea3be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_choice_vue__ = __webpack_require__(398);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_choice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6dea3be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_choice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_c('v-list',_vm._l((_vm.choices),function(item,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.label)+" - "+_vm._s(item.value)+" points")])],1)],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addChoiceForm_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f60ffe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addChoiceForm_vue__ = __webpack_require__(400);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addChoiceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f60ffe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addChoiceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-form',[_c('v-card-text',[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Insert Choice here...","required":""},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Points","required":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Submit")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.questions),function(question,i){return _c('v-expansion-panel-content',{key:i},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Question:")]),_vm._v(" "+_vm._s(question.question))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey darken"},[_c('v-btn',{staticClass:"primary",on:{"click":function($event){return _vm.onClick(question.id)}}},[_vm._v("Add Choice")]),_vm._v(" "),_c('choice',{attrs:{"apiUrl":_vm.apiUrl,"questionId":question.id,"choices":question.choices}})],1)],1)],1)}),1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.addChoiceForm),callback:function ($$v) {_vm.addChoiceForm=$$v},expression:"addChoiceForm"}},[_c('add-choice-form',{attrs:{"apiUrl":_vm.apiUrl,"selectedQuestionId":_vm.selectedQuestionId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-form',[_c('v-card-title',[_c('h3',[_vm._v("Module "+_vm._s(_vm.moduleId))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-flex',[_c('strong',[_vm._v("Author:")]),_vm._v(" "+_vm._s(_vm.author)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("Category:")]),_vm._v(" "+_vm._s(_vm.category)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("CPD Points:")]),_vm._v(" "+_vm._s(_vm.cpdPoints)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("Created At:")]),_vm._v(" "+_vm._s(_vm.createdAt)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("Description:")]),_vm._v(" "+_vm._s(_vm.description)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("Image:")]),_vm._v(" "+_vm._s(_vm.image)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("Minimum Score:")]),_vm._v(" "+_vm._s(_vm.minimumScore)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("Title:")]),_vm._v(" "+_vm._s(_vm.title)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("User Id:")]),_vm._v(" "+_vm._s(_vm.userId)+"\n              ")]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v("Video:")]),_vm._v(" "+_vm._s(_vm.video)+"\n              ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.dialogAddQuestion = true}}},[_vm._v("Add Question")])],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.dialogAddQuestion),callback:function ($$v) {_vm.dialogAddQuestion=$$v},expression:"dialogAddQuestion"}},[_c('add-question-form',{attrs:{"apiUrl":_vm.apiUrl,"moduleId":_vm.moduleId}})],1),_vm._v(" "),_c('question',{attrs:{"apiUrl":_vm.apiUrl,"moduleId":_vm.moduleId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491da8b3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(404);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491da8b3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',[_vm._v(_vm._s(_vm.message))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687637aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(406);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687637aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('h2',[_vm._v("RESET PASSWORD")]),_vm._v(" "),_c('v-form',{directives:[{name:"mode",rawName:"v-mode",value:(_vm.valid),expression:"valid"}],ref:"form",attrs:{"lazy-validation":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Email-Address","rules":_vm.emaiRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Confirm-password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password_confirmation),callback:function ($$v) {_vm.password_confirmation=$$v},expression:"password_confirmation"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-right":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.onClickSubmitReset}},[_vm._v("Submit")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddbb2cd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_vue__ = __webpack_require__(408);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddbb2cd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('img',{attrs:{"height":_vm.imgHeight,"src":_vm.logo}})])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":""}},[_c('v-btn',{staticClass:"accent",attrs:{"to":"/dashboard"}},[_c('strong',[_vm._v("Back")])])],1)],1)],1),_vm._v(" "),_c('v-container',[_c('h3',[_vm._v("PRIVACY STATEMENT")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ol',[_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("MERCK, INC. General Terms and Conditions.")])]),_vm._v(" "),_c('p',[_vm._v("\n        Access to and use of this website are both subject to the following\n        conditions. Should you disagree with these conditions, please do not\n        use this website.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        This website is operated by IPADAMA 360 INC., a service provider of\n        Merck, Inc. (hereinafter also “Merck”, “we”, “us” or “our”).\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        This website is for general informational and educational purposes\n        only and, although it may be available in different languages, it is\n        not country specific. By using this website you declare that you use\n        it and its content at your own risk.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Under no circumstances may this website or its contents may be used or\n        understood as a substitute for healthcare professional advice and is\n        not to be used for diagnosis of any health problem or disease.\n        Patients should always consult a doctor or another healthcare\n        professional for medical advice or information about diagnosis and\n        treatment. If your situation is serious, always call the emergency\n        service.\n      ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("1. Exclusion of liability")])]),_vm._v(" "),_c('p',[_vm._v("\n        We have compiled the content of this website carefully and in\n        accordance with the current state of knowledge. However, we give no\n        warranty, neither expressly nor tacitly, for the completeness or\n        correctness of the details provided on this website. Please be aware,\n        in particular, that the details we provide may no longer be\n        up-to-date.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Access to and use of this website and of any associated sites or sites\n        connected via links take place at the user’s own risk. We accept no\n        liability for loss, damage or compensation claims due to missing or\n        incorrect details. The Website and any services available through it\n        are available solely for the User's personal and not for commercial\n        use.\n      ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("2. Legal notes")])]),_vm._v(" "),_c('p',[_vm._v("\n        All rights to the website or arising from the same shall remain with\n        Merck, Inc. or its affiliates.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We may modify this website and/or discontinue its operation at any\n        time without prior announcement, either wholly or in parts, at ourits\n        own discretion and without accepting liability. Neither is Merck,\n        under an obligation to update the content of this website.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Unless otherwise indicated, all details, documents and presentations\n        published on our website are under the sole ownership of Merck, Inc.,\n        its affiliates or third parties that have authorized its use. Unless\n        written consent has been obtained from us, no permission is given to\n        import published and copyrighted content from our website to other\n        programs or website or to use such content in any other way.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Access to this website is public and does not require registration.\n        Please, be aware that users may be subject to provisions under local\n        legislation. International users must observe the special provisions\n        under local legislation. Users in the United States are subject to the\n        conditions of use for the websites of our U.S. companies.\n      ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("3. Personal data")])]),_vm._v(" "),_c('p',[_vm._v("\n        We are concerned to ensure the protection of your personal data. You\n        will find information on the use of personal data in the Privacy\n        Statement.\n      ")]),_vm._v(" "),_c('li',[_c('strong',{staticClass:"accent--text"},[_vm._v("4. Content")])]),_vm._v(" "),_c('p',[_vm._v("\n        This website may contain general information regarding medical\n        conditions. Such information is provided for informational purposes\n        only, under no circumstances may it be used or understood as a\n        substitute for healthcare professional advice and is not to be used\n        for diagnosis of any health problem or disease. Patients should always\n        consult a doctor or another healthcare professional for medical advice\n        or information about diagnosis and treatment.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        The website may also include links to third-party websites. Such links\n        are provided merely as a convenience. The content of third-party web\n        sites is beyond our control and we make no warranties or\n        representations regarding the accuracy or validity of such\n        information. Neither do the links represent any kind of support or\n        endorsement of the linked website's contents. Access to and use of\n        sites connected via links take place at the user’s own risk.\n      ")]),_vm._v(" "),_c('p',[_vm._v("As of: April 2024")])]),_vm._v(" "),_c('h3',[_vm._v("CONTACT US")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("You may contact us at medinfoph@merckgroup.com.")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date of last update: December 2023.")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 409 */,
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = middleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middleware_RedirectIfAuthenticated__ = __webpack_require__(414);


function middleware(router) {
  Object(__WEBPACK_IMPORTED_MODULE_0__middleware_RedirectIfAuthenticated__["a" /* default */])(router);
}

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedirectIfAuthenticated;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_token__ = __webpack_require__(10);


function RedirectIfAuthenticated(router) {
  router.beforeEach(function (to, from, next) {
    var token = Object(__WEBPACK_IMPORTED_MODULE_0__utils_token__["c" /* getAuthToken */])();
    var auth = to.meta.requiresAuth;
    /**
    * check if pages requiresAuth
    */
    if (auth) {
      /**
      * check if there's a token
      */
      if (token) {
        next();
        return;
      }
      next('/login');
      return;
    }
    next();
  });
}

/***/ })
],[241]);


// WEBPACK FOOTER //
// static/js/app.279b41ec5aef97ae435b.js